import Tabulator from 'tabulator-tables';
import '@activix/double-scroll';
import {reInitScripts} from "../utils/re-init-scripts";
import {declOfNum} from "../utils/decl-of-num";
import XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import {notifier} from "./notifier";
import $ from "jquery";
import cookieData from './cookie-data';
import {paginate} from "../utils/pagination";
// import 'print-this';
import printJS from "print-js";
window.XLSX = XLSX;

const $body = $('body');

function tabulator(elements) {
    const translates = window.translates['tabulator'];
    const translates2 = window.translates['loyalty'];
    translates.volumeLabel = translates.volumeLabel.replace(/&#39;/g, "'");
    translates.status12 = translates.status12.replace(/&#39;/g, "'");
    translates.status13 = translates.status13.replace(/&#39;/g, "'");
    
    $(document).on('submit', 'form', function (e) {
        const $this = $(this);
        
        if ($this.hasClass('ajax-form')) {
            e.preventDefault();
        }
    });

    $(elements).each((i, el) => {
        let filters = {
            'number': 'receiptNumberEditor',
            'status': 'receiptStatusEditor',
            'dateSend': 'receiptDateSendEditor',
            'dateReceive': 'receiptDateReceiveEditor',
            'warehouseSend': 'receiptWarehouseSendEditor',
            'warehouseReceive': 'receiptWarehouseReceiveEditor',
            'paymentStatus': 'receiptPaymentStateEditor',
            'payType': 'receiptPaymentStatusEditor',
            'receiver': 'receiptReceiverEditor',
            'forwarderWeight': 'receiptWeightEditor',
            'dateDeliveryPlan': 'receiptDateDeliveryPlanEditor',
            'forwarderSize': 'receiptVolumeEditor',
            'DateGivingOut': 'receiptDateGivingOutEditor',
            'cashPayMentDate': 'receiptDateCashPaymentEditor',
            'sender': 'receiptSenderEditor',
            'teyStatus': 'teyStatusEditor',
            'insurancePaymentStatus': 'insurancePaymentStatusEditor',
            'cashOnDeliveryPaymentStatus': 'cashOnDeliveryPaymentStatusEditor',
            'archiveYear': 'receiptsArchiveYearEditor'
        };
        let formatters = {
            'LockShipping': 'lockShippingFormatter',
            'payType': 'payTypeFormatter',
            'paymentStatus': 'paymentStatusFormatter',
            'date': 'dateFormatter',
        };
        const $wrapper = $('[data-tabulator]');
        const $el = $(el);
        const url = $el.data('url');
        const headerUrl = $el.data('header-url');
        const $tableToolbarButtons = $('[data-table-toolbar]').find('.button').filter('[disabled]');
        const $tableToolbarButtonsEnable = $('[data-table-toolbar]').find('.button');
        const $payTeyButton = $('[data-pay-tey]');
        const $payInsuranceButton = $('[data-pay-insurance]');
        const $selectAll = $('#selectAll');
        let $paginator = $('.tabulator-paginator');
        const $exportExcel = $('[data-export-excel]');
        const $print = $('[data-print]');
        const $printRegistered = $('[data-print-registered]');
        const $toArchive = $('[data-to-archive]');
        const $loyaltyHeader = $('[data-loyalty-header]');
        const $toDelete = $('[data-to-delete-action]');
        
        let rows = [];
        let initialData = [];
        let loyaltyData = [];
        let unpaidReceiptsIds = [];
        const unpaidReceiptsSelected = {
            tey: [],
            insurance: []
        };
        const warehouseUrl = $el.data('warehouse-url');
        const tableType = $el.data('table-type');
        let table;
        let receiptPageSize = cookieData.receive('receiptSize') || 10;
        let receiptCurrentPage = 1;
        let receiptTotalPages = 0;
        let ordersPageSize = cookieData.receive('ordersSize') || 10;
        let ordersCurrentPage = 1;
        let ordersTotalPages = 0;
        let archivePageSize = cookieData.receive('archiveSize') || 10;
        let archiveCurrentPage = 1;
        let archiveTotalPages = 0;
        let reclamationPageSize = cookieData.receive('reclamationSize') || 10;
        let reclamationCurrentPage = 1;
        let reclamationTotalPages = 0;
        let unpaidReceiptsPageSize = cookieData.receive('receiptSize') || 10;
        let unpaidReceiptsCurrentPage = 1;
        let unpaidReceiptsTotalPages = 0;

        let today = new Date();
        let twoWeeksAgo = new Date(Date.parse(today) - 1209600000);

        let URLParams = new URLSearchParams(window.location.href.split('?')[1]);
        let URLParamsSearch = new URLSearchParams(window.location.href.split('&')[1]);

        $el.filters = {};
        $el.filterLists = {};
        $el.filters.sord = 'desc';
        $el.filters.number = null;

        $el.filters.dateFrom = null;
        $el.filters.dateTo = null;
        $el.filters.dateFromReceive = null;
        $el.filters.dateToReceive = null;
        $el.filters.isNotReserved = null;

        $el.filters.state = URLParams.get('state');
        $el.filters.senderId = URLParamsSearch.get('senderId');
        $el.filters.receiverId = URLParamsSearch.get('receiverId');
        $el.filters.statusList = URLParams.get('status') || null;
        $el.filters.isPaymentStatus = URLParams.get('paymentStatus');
        $el.filters.isInsurancePaymentStatus = URLParams.get('insuranceStatus');
        $el.filters.unpaidCOD = URLParams.get('unpaidCOD');
        $el.filters.ungivenCOD = URLParams.get('ungivenCOD');

        $body.addClass('is-loading');

        if (tableType === 'receipts') {
            $el.filters.sidx = 'CreationDate';
            $el.filters.dateFrom = twoWeeksAgo.toLocaleDateString(window.currentLang);
            $el.filters.dateTo = today.toLocaleDateString(window.currentLang);
        } else if (tableType === 'ordersList' || tableType === 'archive') {
            $el.filters.sidx = 'DispatchingDate';
        }

        if($el.filters.state || $el.filters.senderId || $el.filters.receiverId || $el.filters.statusList || $el.filters.unpaidCOD || $el.filters.ungivenCOD) {
            $('[data-filter-container]').remove();
            $el.filters.dateFrom = null;
            $el.filters.dateTo = null;
        }

        let lockShippingFormatter = function (cell, formatterParams, onRendered) {
            let val = cell.getValue();
            if (val) {
                return translates.lockShipping
            }

            return '';
        };

        let receiptStatusFormatter = function (cell, formatterParams, onRendered) {
            let row = cell.getRow();
            let statusCell = row.getCell('status');
            let statusVal = parseInt(statusCell.getData(), 10);
            return cell.getValue()
        };

        let payTypeFormatter = function (cell, formatterParams, onRendered) {
            let val = cell.getValue();
            if (!parseInt(val)) {
                return translates.payCashless;
            }
            return translates.payCash;
        };

        let paymentStatusFormatter = function (cell, formatterParams, onRendered) {
            let val = cell.getValue();
            if (!val) {
                return translates.unpayed;
            }
            return translates.payed;
        };

        let dateFormatter = function (cell, formatterParams, onRendered) {
            const val = cell.getValue();
            const timestamp = /\((.*?)\)/.exec(val);
            const date = new Date(parseInt(timestamp[1]));
            return date.toLocaleDateString('ru-RU');
        };

        let receiptNumberEditor = function (cell, onRendered, success, cancel, editorParams) {
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" class="form-item__control">
                                            <label class="form-item__label">${translates.receiptNumberLabel}</label>
                                        </div>
                                    </div>
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-sm" data-reset><div class="button__text">${translates.reset}</div></div>
                                </form>
                            </div>
                        </div>`);
            let prevVal = '';

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                input.val('');
                input.trigger('change');
                btn.removeClass('is-filtered');
                prevVal = '';
            });

            input.change(() => {
                btn.trigger('click');
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        $el.filters.number = input.val();
                        btn.addClass('is-filtered');
                    } else {
                        delete $el.filters.number;
                        btn.removeClass('is-filtered');
                    }
                    prevVal = input.val();
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            });

            return editor.get(0);
        };

        let receiptStatusEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevValues = [];
            let values = [];
            const statusDictionary = [
                translates.status0,
                translates.status1,
                translates.status2,
                translates.status6,
                translates.status7,
                translates.status8,
                translates.status9,
                translates.status10,
                translates.status11,
                translates.status12,
                translates.status13,
            ];
            let checkboxes = statusDictionary.map((item, index) => {
                let i = index > 2 ? index + 3 : index;
                return (`<div class="checkbox _my-xs _vw:my-xs">
                            <input type="checkbox" class="checkbox__control" name='statusList' ${parseInt(URLParams.get('status')) === i ? 'checked' : ''} value="${i}" id="statusList${i}"/>
                            <label class="checkbox__label" for="statusList${i}">
                                <span class="checkbox__checkmark">
                                    <svg>
                                        <use xlink:href="#checkmark"></use>
                                    </svg>
                                </span>
                                <span class="checkbox__text _fz-xs _color-black _text-left">${item}</span>
                            </label>
                        </div>`);
            });
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-xs _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>      
                                    </div>
                                    ${checkboxes.join('')}
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            if($el.filters.statusList) {
                input.trigger('change');
                prevValues.push($el.filters.statusList);
                btn.addClass('is-filtered');
            }

            reset.click(() => {
                input.prop('checked', false).trigger('change');
                values = [];
                confirm.trigger('click');
            });

            input.on('change', function () {
                values = [];
                input.filter(':checked').each((i, el) => {
                    values.push(el.value);
                });
            });

            confirm.on('click', () => {
                if (JSON.stringify(prevValues) !== JSON.stringify(values)) {
                    if (values.length > 0) {
                        $el.filters.statusList = values;
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.statusList;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    window.tableData = [];
                    showInfo();
                    prevValues = values;
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            });

            return editor.get(0);
        };

        let receiptPaymentStateEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-xs" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="paymentType1" name="paymentState" type="radio" value="true">
                                        <label class="radio-button__label" for="paymentType1">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.payed}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="paymentType2" name="paymentState" type="radio" value="false">
                                        <label class="radio-button__label" for="paymentType2">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.unpayed}</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                input.prop('checked', false).trigger('change');
                btn.removeClass('is-filtered').trigger('click');
                prevVal = '';
            });

            input.on('change', () => {
                if (prevVal !== input.filter(':checked').val()) {
                    $el.filters.paymentState = input.filter(':checked').val();
                    btn.addClass('is-filtered').trigger('click');
                    prevVal = input.filter(':checked').val();
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let teyStatusEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-xs" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="teyType1" ${parseInt(URLParams.get('paymentStatus')) === 1 ? 'checked' : '' } name="teyStatus" type="radio" value="1">
                                        <label class="radio-button__label" for="teyType1">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.payed}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="teyType2" ${parseInt(URLParams.get('paymentStatus')) === 0 ? 'checked' : '' } name="teyStatus" type="radio" value="0">
                                        <label class="radio-button__label" for="teyType2">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.unpayed}</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let isResetting = false;

            reset.click(() => {
                isResetting = true;
                input.prop('checked', false).trigger('change');
                btn.removeClass('is-filtered').trigger('click');
                prevVal = '';
            });

            if ($el.filters.isPaymentStatus) {
                input.val($el.filters.isPaymentStatus).trigger('change');
                prevVal = input.val();
                btn.addClass('is-filtered');
            }

            input.on('change', () => {
                if (prevVal !== input.filter(':checked').val()) {
                    const val = parseInt(input.filter(':checked').val());
                    $el.filters.isPaymentStatus = !isNaN(val) ? val : null;
                    if (!isResetting) {
                        btn.addClass('is-filtered').trigger('click');
                    }
                    prevVal = input.filter(':checked').val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size, 'rows', true);
                    isResetting = false;
                }
            })

            return editor.get(0);
        };

        let insurancePaymentStatusEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-xs" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="insuranceType1" ${parseInt(URLParams.get('insuranceStatus')) === 1 ? 'checked' : '' } name="insuranceStatus" type="radio" value="1">
                                        <label class="radio-button__label" for="insuranceType1">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.payed}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="insuranceType2" ${parseInt(URLParams.get('insuranceStatus')) === 0 ? 'checked' : '' } name="insuranceStatus" type="radio" value="0">
                                        <label class="radio-button__label" for="insuranceType2">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.unpayed}</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let isResetting = false;

            reset.click(() => {
                isResetting = true;
                input.prop('checked', false).trigger('change');
                btn.removeClass('is-filtered').trigger('click');
                prevVal = '';
            });

            if ($el.filters.isInsurancePaymentStatus) {
                input.val($el.filters.isInsurancePaymentStatus).trigger('change');
                prevVal = input.val();
                btn.addClass('is-filtered');
            }

            input.on('change', () => {
                if (prevVal !== input.filter(':checked').val()) {
                    const val = parseInt(input.filter(':checked').val());
                    $el.filters.isInsurancePaymentStatus = !isNaN(val) ? val : null;
                    if (!isResetting) {
                        btn.addClass('is-filtered').trigger('click');
                    }
                    prevVal = input.filter(':checked').val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size, 'rows', true);
                    isResetting = false;
                }
            })

            return editor.get(0);
        };

        let cashOnDeliveryPaymentStatusEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-xs" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="deliveryPaymentType1" name="deliveryPaymentStatus" type="radio" value="1">
                                        <label class="radio-button__label" for="deliveryPaymentType1">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.payed}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="deliveryPaymentType2" name="deliveryPaymentStatus" type="radio" value="0">
                                        <label class="radio-button__label" for="deliveryPaymentType2">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.unpayed}</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let isResetting = false;

            reset.click(() => {
                isResetting = true;
                input.prop('checked', false).trigger('change');
                btn.removeClass('is-filtered').trigger('click');
                prevVal = '';
            });

            input.on('change', () => {
                if (prevVal !== input.filter(':checked').val()) {
                    const val = parseInt(input.filter(':checked').val());
                    $el.filters.isCashOnDeliveryPaymentStatus = !isNaN(val) ? val : null;
                    if (!isResetting) {
                        btn.addClass('is-filtered').trigger('click');
                    }
                    prevVal = input.filter(':checked').val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size, 'rows', true);
                    isResetting = false;
                }
            })

            return editor.get(0);
        };

        let receiptPaymentStatusEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-xs" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="payType1" name="paymentType" type="radio" value="1">
                                        <label class="radio-button__label" for="payType1">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.payCash}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="payType2" name="paymentType" type="radio" value="0">
                                        <label class="radio-button__label" for="payType2">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.payCashless}</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                input.prop('checked', false).trigger('change');
                prevVal = '';
                btn.removeClass('is-filtered');
            });

            input.on('change', () => {
                if (prevVal !== input.filter(':checked').val()) {
                    $el.filters.payType = input.filter(':checked').val();
                    btn.addClass('is-filtered').trigger('click');
                    prevVal = input.filter(':checked').val();
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let receiptDateSendEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " id="dateSendEditor" data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" readonly class="form-item__control js-import" data-datepicker data-datepicker-parent="[data-dropdown]">
                                            <label class="form-item__label">${translates.departureDate}</label>
                                            <div class="form-item__icon form-item__icon--right">
                                                <svg>
                                                    <use xlink:href="#icon-date"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            if ($el.filters.dateFrom && $el.filters.dateTo) {
                input.val($el.filters.dateFrom + '-' + $el.filters.dateTo).trigger('apply.daterangepicker');
                prevVal = input.val();
                btn.addClass('is-filtered');
            }

            reset.click(() => {
                input.val('').trigger('change');
                confirm.trigger('click');
                prevVal = '';
                btn.removeClass('is-filtered');
            });

            confirm.on('click', () => {
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        let dates = input.val().split('-');
                        $el.filters.dateFrom = dates[0].trim();
                        $el.filters.dateTo = dates[1].trim();
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.dateFrom;
                        delete $el.filters.dateTo;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    window.tableData = [];
                    showInfo();
                    prevVal = input.val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let receiptDateReceiveEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" readonly class="form-item__control js-import" data-datepicker data-datepicker-parent="[data-dropdown]">
                                            <label class="form-item__label">${translates.receiveDate}</label>
                                            <div class="form-item__icon form-item__icon--right">
                                                <svg>
                                                    <use xlink:href="#icon-date"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            reset.click(() => {
                btn.removeClass('is-filtered');
                input.val('').trigger('change');
                confirm.trigger('click');
                prevVal = '';
            });

            confirm.on('click', () => {
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        let dates = input.val().split('-');
                        $el.filters.dateFromReceive = dates[0].trim();
                        $el.filters.dateToReceive = dates[1].trim();
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.dateFromReceive;
                        delete $el.filters.dateToReceive;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    window.tableData = [];
                    showInfo();
                    prevVal = input.val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let receiptDateDeliveryPlanEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" readonly class="form-item__control js-import" data-datepicker data-datepicker-parent="[data-dropdown]">
                                            <label class="form-item__label">${translates.deliveryPlanDate}</label>
                                            <div class="form-item__icon form-item__icon--right">
                                                <svg>
                                                    <use xlink:href="#icon-date"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            reset.click(() => {
                input.val('').trigger('change');
                confirm.trigger('click');
                prevVal = '';
                btn.removeClass('is-filtered');
            });

            confirm.on('click', () => {
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        let dates = input.val().split('-');
                        let dateFrom = dates[0].split('.');
                        let dateTo = dates[1].split('.');
                        dateFrom = dateFrom[1].trim() + '.' + dateFrom[0].trim() + '.' + dateFrom[2].trim();
                        dateTo = dateTo[1].trim() + '.' + dateTo[0].trim() + '.' + dateTo[2].trim();
                        $el.filters.dateFromDeliveryPlan = dateFrom;
                        $el.filters.dateToDeliveryPlan = dateTo;
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.dateFromDeliveryPlan;
                        delete $el.filters.dateToDeliveryPlan;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    window.tableData = [];
                    showInfo();
                    prevVal = input.val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let receiptDateGivingOutEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" readonly class="form-item__control js-import" data-datepicker data-datepicker-parent="[data-dropdown]">
                                            <label class="form-item__label">${translates.dateGivingOut}</label>
                                            <div class="form-item__icon form-item__icon--right">
                                                <svg>
                                                    <use xlink:href="#icon-date"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            reset.click(() => {
                input.val('').trigger('change');
                confirm.trigger('click');
                prevVal = '';
            });

            confirm.on('click', () => {
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        let dates = input.val().split('-');
                        $el.filters.dateGivingFrom = dates[0].trim();
                        $el.filters.dateGivingTo = dates[1].trim();
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.dateGivingFrom;
                        delete $el.filters.dateGivingTo;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    window.tableData = [];
                    showInfo();
                    prevVal = input.val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let receiptDateCashPaymentEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" readonly class="form-item__control js-import" data-datepicker data-datepicker-parent="[data-dropdown]">
                                            <label class="form-item__label"></label>
                                            <div class="form-item__icon form-item__icon--right">
                                                <svg>
                                                    <use xlink:href="#icon-date"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
</form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            reset.click(() => {
                input.val('').trigger('change');
                prevVal = '';
            });

            confirm.on('click', () => {
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        let dates = input.val().split('-');
                        $el.filters.dateCODPayingFrom = dates[0].trim();
                        $el.filters.dateCODPayingTo = dates[1].trim();
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.dateCODPayingFrom;
                        delete $el.filters.dateCODPayingTo;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    window.tableData = [];
                    showInfo();
                    prevVal = input.val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let receiptWarehouseSendEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-sm" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-height-df _control-padding-xs">
                                        <div class="form-item__body">
                                            <input type="text" class="form-item__control" data-search/>
                                            <span class="form-item__label">${translates.search}</span>
                                        </div>
                                    </div>
                                    <ul class="dropdown-list" data-warehouse-list>
                                    </ul>
                                </form>
                            </div>
                        </div>`);

            const $warehouseList = editor.find('[data-warehouse-list]');

            $.ajax({
                url: warehouseUrl,
                type: 'get',
                data: {
                    isFilterToRegionalCentres: false
                },
                success: (response) => {
                    let warehouseItems = response.map((item, index) => {
                        return (`
                            <li id="${item['Id']}" class="warehouse-list__item">
                                ${item['Name']}
                            </li>
                        `)
                    });
                    $warehouseList.html(warehouseItems.join(''));
                }
            });


            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');

            input.on('keyup', function () {
                let value = $(this).val().toLowerCase();
                $warehouseList.find('li').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                });
            });

            $warehouseList.on('click', 'li', function () {
                let chosen = $(this);
                $warehouseList.find('li').removeClass('is-active');
                $el.filters.warehouseSendId = chosen.attr('id');
                chosen.addClass('is-active');
                btn.addClass('is-filtered').trigger('click');
                if (prevVal !== chosen.attr('id')) {
                    window.tableData = [];
                    showInfo();
                    prevVal = chosen.attr('id')
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                $warehouseList.find('li').removeClass('is-active');
                delete $el.filters.warehouseSendId;
                btn.removeClass('is-filtered').trigger('click');
                let page = getPage(tableType);
                let size = getPageSize(tableType);
                updateTable(1, size);
                prevVal = '';
            });

            return editor.get(0);
        };

        let receiptWarehouseReceiveEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-sm" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-height-df _control-padding-xs">
                                        <div class="form-item__body">
                                            <input type="text" class="form-item__control" data-search/>
                                            <span class="form-item__label">${translates.search}</span>
                                        </div>
                                    </div>
                                    <ul class="dropdown-list" data-warehouse-list>
                                    </ul>
                                </form>
                            </div>
                        </div>`);

            const $warehouseList = editor.find('[data-warehouse-list]');

            $.ajax({
                url: warehouseUrl,
                type: 'get',
                data: {
                    isFilterToRegionalCentres: false
                },
                success: (response) => {
                    let warehouseItems = response.map((item, index) => {
                        return (`
                            <li id="${item['Id']}" class="warehouse-list__item">
                                ${item['Name']}
                            </li>
                        `)
                    });
                    $warehouseList.html(warehouseItems.join(''));
                }
            });

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');

            input.on('keyup', function () {
                let value = $(this).val().toLowerCase();
                $warehouseList.find('li').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                });
            });

            $warehouseList.on('click', 'li', function () {
                let chosen = $(this);
                $warehouseList.find('li').removeClass('is-active');
                $el.filters.warehouseReceiveId = chosen.attr('id');
                chosen.addClass('is-active');
                btn.addClass('is-filtered').trigger('click');
                if (prevVal !== chosen.attr('id')) {
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                $warehouseList.find('li').removeClass('is-active');
                delete $el.filters.warehouseReceiveId;
                btn.removeClass('is-filtered').trigger('click');
                let page = getPage(tableType);
                let size = getPageSize(tableType);
                updateTable(1, size);
                prevVal = '';
            });

            return editor.get(0);
        };

        let receiptReceiverEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-sm" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-height-df _control-padding-xs">
                                        <div class="form-item__body">
                                            <input type="text" class="form-item__control" data-search/>
                                            <span class="form-item__label">${translates.search}</span>
                                        </div>
                                    </div>
                                    <ul class="dropdown-list" data-receiver-list>
                                    </ul>
                                </form>
                            </div>
                        </div>`);

            const $receiverList = editor.find('[data-receiver-list]');

            $.ajax({
                url: GLOBAL_APP_PATH + '/' + window.currentLang + '/UserReceipts/getClientReceivers',
                type: 'POST',
                data: $el.filters,
                success: (response) => {
                    let receiverItems = response.map((item, index) => {
                        return (`
                            <li id="${item['Value']}" class="dropdown-list__item ${URLParamsSearch.get('receiverId') === item['Value'] ? 'is-active' : '' }">
                                ${item['Text']}
                            </li>
                        `)
                    });
                    $receiverList.html(receiverItems.join(''));
                }
            });

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');

            input.on('keyup', function () {
                let value = $(this).val().toLowerCase();
                $receiverList.find('li').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                });
            });

            if($el.filters.receiverId) {
                prevVal = $el.filters.receiverId;
                $receiverList.trigger('click');
                btn.addClass('is-filtered');
            }

            $receiverList.on('click', 'li', function () {
                let chosen = $(this);
                $receiverList.find('li').removeClass('is-active');
                $el.filters.receiverId = chosen.attr('id');
                chosen.addClass('is-active');
                if (prevVal !== chosen.attr('id')) {
                    btn.addClass('is-filtered').trigger('click');
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                $receiverList.find('li').removeClass('is-active');
                delete $el.filters.receiverId;
                btn.removeClass('is-filtered').trigger('click');
                let page = getPage(tableType);
                let size = getPageSize(tableType);
                updateTable(1, size);
                prevVal = '';
            });

            return editor.get(0);
        };

        let receiptSenderEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-sm" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-height-df _control-padding-xs">
                                        <div class="form-item__body">
                                            <input type="text" class="form-item__control" data-search/>
                                            <span class="form-item__label">${translates.search}</span>
                                        </div>
                                    </div>
                                    <ul class="dropdown-list" data-sender-list>
                                    </ul>
                                </form>
                            </div>
                        </div>`);

            const $senderList = editor.find('[data-sender-list]');

            $.ajax({
                url: GLOBAL_APP_PATH + '/' + window.currentLang + '/UserReceipts/getSenderListInMyReceipts',
                type: 'get',
                success: (response) => {
                    let senderItems = response.map((item, index) => {
                        return (`
                            <li id="${item['Value']}" class="dropdown-list__item ${URLParamsSearch.get('senderId') === item['Value'] ? 'is-active' : '' }">
                                ${item['Text']}
                            </li>
                        `)
                    });
                    $senderList.html(senderItems.join(''));
                }
            });

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');

            input.on('keyup', function () {
                let value = $(this).val().toLowerCase();
                $senderList.find('li').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                });
            });

            if($el.filters.senderId) {
                prevVal = $el.filters.senderId;
                $senderList.trigger('click');
                btn.addClass('is-filtered');
            }

            $senderList.on('click', 'li', function () {
                let chosen = $(this);
                $senderList.find('li').removeClass('is-active');
                $el.filters.senderId = chosen.attr('id');
                chosen.addClass('is-active');
                if (prevVal !== chosen.attr('id')) {
                    btn.addClass('is-filtered').trigger('click');
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                $senderList.find('li').removeClass('is-active');
                delete $el.filters.senderId;
                btn.removeClass('is-filtered').trigger('click');

                let page = getPage(tableType);
                let size = getPageSize(tableType);
                updateTable(1, size);
                prevVal = '';
            });

            return editor.get(0);
        };

        let receiptWeightEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevValFrom = '',
                prevValTo = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" name="weightFrom" class="form-item__control">
                                            <label class="form-item__label">${translates.weightFrom}</label>
                                        </div>
                                    </div>
                                    <div class="form-item form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" name="weightTo" class="form-item__control">
                                            <label class="form-item__label">${translates.weightTo}</label>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let inputFrom = editor.find('input[name="weightFrom"]');
            let inputTo = editor.find('input[name="weightTo"]');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            reset.click(() => {
                inputFrom.val('').trigger('change');
                inputTo.val('').trigger('change');
                confirm.trigger('click');
                btn.removeClass('is-filtered');
                prevValFrom = '';
                prevValTo = '';
            });

            confirm.on('click', () => {
                if (prevValFrom !== inputFrom.val() || prevValTo !== inputTo.val()) {
                    btn.addClass('is-filtered').trigger('click');
                    if (inputFrom.val().length > 0) {
                        $el.filters.totalWeightFrom = inputFrom.val().replace(',', '.');
                    } else {
                        delete $el.filters.totalWeightFrom;
                    }
                    if (inputTo.val().length > 0) {
                        $el.filters.totalWeightTo = inputTo.val();
                    } else {
                        delete $el.filters.totalWeightTo;
                    }
                    prevValFrom = inputFrom.val();
                    prevValTo = inputTo.val();
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                } else {
                    btn.removeClass('is-filtered').trigger('click');
                }
            });

            return editor.get(0);
        };

        let receiptVolumeEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevValFrom = '',
                prevValTo = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" name="volumeFrom" class="form-item__control">
                                            <label class="form-item__label">${translates.weightFrom}</label>
                                        </div>
                                    </div>
                                    <div class="form-item form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" name="volumeTo" class="form-item__control">
                                            <label class="form-item__label">${translates.weightTo}</label>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let inputFrom = editor.find('input[name="volumeFrom"]');
            let inputTo = editor.find('input[name="volumeTo"]');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            reset.click(() => {
                inputFrom.val('').trigger('change');
                inputTo.val('').trigger('change');
                confirm.trigger('click');
                btn.removeClass('is-filtered')
                prevValFrom = '';
                prevValTo = '';
            });

            confirm.on('click', () => {
                if (prevValFrom !== inputFrom.val() || prevValTo !== inputTo.val()) {
                    btn.addClass('is-filtered').trigger('click');
                    if (inputFrom.val().length > 0) {
                        $el.filters.totalVolumeFrom = inputFrom.val();
                    } else {
                        delete $el.filters.totalVolumeFrom;
                    }
                    if (inputTo.val().length > 0) {
                        $el.filters.totalVolumeTo = inputTo.val();
                    } else {
                        delete $el.filters.totalVolumeTo;
                    }
                    prevValFrom = inputFrom.val();
                    prevValTo = inputTo.val();
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                } else {
                    btn.removeClass('is-filtered').trigger('click');
                }
            });

            return editor.get(0);
        };

        let ordersNumberEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" class="form-item__control">
                                            <label class="form-item__label">${translates.appNumberLabel}</label>
                                        </div>
                                    </div>
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-sm" data-reset><div class="button__text">${translates.reset}</div></div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                input.val('').trigger('change');
                btn.removeClass('is-filtered');
                prevVal = '';
            });

            input.on('change', () => {
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        $el.filters.appNumber = input.val();
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.appNumber;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    prevVal = input.val();
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let ordersDateCreateEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" readonly class="form-item__control js-import" data-datepicker data-datepicker-parent="[data-dropdown]">
                                            <label class="form-item__label">${translates.creationDate}</label>
                                            <div class="form-item__icon form-item__icon--right">
                                                <svg>
                                                    <use xlink:href="#icon-date"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            reset.click(() => {
                input.val('').trigger('change');
                btn.removeClass('is-filtered');
                confirm.trigger('click');
                prevVal = '';
            });

            confirm.on('click', () => {
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        let dates = input.val().split('-');
                        $el.filters.dateFrom = dates[0].trim();
                        $el.filters.dateTo = dates[1].trim();
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.dateFrom;
                        delete $el.filters.dateTo;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    window.tableData = [];
                    showInfo();
                    prevVal = input.val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let ordersAppStateEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-xs" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="appState1" ${parseInt(URLParams.get('state')) === 100000000 ? 'checked' : '' } name="appState" type="radio" value="100000000">
                                        <label class="radio-button__label" for="appState1">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.appStatus.created}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="appState2" ${parseInt(URLParams.get('state')) === 100000001 ? 'checked' : '' } name="appState" type="radio" value="100000001">
                                        <label class="radio-button__label" for="appState2">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.appStatus.opened}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="appState3" ${parseInt(URLParams.get('state')) === 100000002 ? 'checked' : '' } name="appState" type="radio" value="100000002">
                                        <label class="radio-button__label" for="appState3">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.appStatus.closed}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="appState4" ${parseInt(URLParams.get('state')) === 100000003 ? 'checked' : '' } name="appState" type="radio" value="100000003">
                                        <label class="radio-button__label" for="appState4">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.appStatus.canceled}</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');

            if ($el.filters.state) {
                input.val($el.filters.state).trigger('change');
                prevVal = input.val();
                btn.addClass('is-filtered');
            }

            reset.click(() => {
                input.prop('checked', false).trigger('change');
                btn.removeClass('is-filtered').trigger('click');
                prevVal = '';
            });
            input.on('change', () => {
                if (prevVal !== input.filter(':checked').val()) {
                    $el.filters.state = input.filter(':checked').val();
                    btn.addClass('is-filtered').trigger('click');
                    prevVal = input.filter(':checked').val();
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let ordersAppTypeEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-xs" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="appType1" name="appType" type="radio" value="0">
                                        <label class="radio-button__label" for="appType1">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.appPickUp}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="appType2" name="appType" type="radio" value="1">
                                        <label class="radio-button__label" for="appType2">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.appDelivery}</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                input.prop('checked', false).trigger('change');
                btn.removeClass('is-filtered');
                prevVal = '';
            });

            input.on('change', () => {
                if (prevVal !== input.filter(':checked').val()) {
                    $el.filters.pickDeliv = input.filter(':checked').val();
                    btn.addClass('is-filtered').trigger('click');
                    prevVal = input.filter(':checked').val();
                    window.tableData = [];
                    showInfo();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let reclamationDecisionNameEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator _p-sm _vw:p-sm" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-xs" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="stateName1" name="stateName" type="radio" value="100000000">
                                        <label class="radio-button__label" for="stateName1">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.stateName.state0}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="stateName2" name="stateName" type="radio" value="100000001">
                                        <label class="radio-button__label" for="stateName2">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.stateName.state1}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="stateName3" name="stateName" type="radio" value="100000002">
                                        <label class="radio-button__label" for="stateName3">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray _white-space-normal">${translates.stateName.state2}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="stateName4" name="stateName" type="radio" value="100000003">
                                        <label class="radio-button__label" for="stateName4">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.stateName.state3}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="stateName5" name="stateName" type="radio" value="100000004">
                                        <label class="radio-button__label" for="stateName5">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray _white-space-normal">${translates.stateName.state4}</span>
                                        </label>
                                    </div>
                                    <div class="radio-button _mt-md _vw:mt-md">
                                        <input class="radio-button__control" id="stateName6" name="stateName" type="radio" value="100000005">
                                        <label class="radio-button__label" for="stateName6">
                                            <span class="radio-button__checkmark _mr-md _vw:mr-md"></span>
                                            <span class="radio-button__text text _fz-xs _color-pantone-gray">${translates.stateName.state5}</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                input.prop('checked', false).trigger('change');
                btn.removeClass('is-filtered');
                prevVal = '';
            });

            input.on('change', () => {
                if (prevVal !== input.filter(':checked').val()) {
                    $el.filters.state = input.filter(':checked').val();
                    btn.addClass('is-filtered').trigger('click');
                    prevVal = input.filter(':checked').val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let reclamationDateCreateEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--squared form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" readonly class="form-item__control js-import" data-datepicker data-datepicker-parent="[data-dropdown]">
                                            <label class="form-item__label">${translates.reclamationList.dateFixation}</label>
                                            <div class="form-item__icon form-item__icon--right">
                                                <svg>
                                                    <use xlink:href="#icon-date"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="_flex _justify-between _items-center _px-sm _vw:px-sm">
                                        <div class="button button--theme-transparent _color-red _b-r-none button--size-sm _pl-none" data-reset><div class="button__text">${translates.reset}</div></div>
                                        <div class="button button--theme-yellow _color-black button--br-df button--size-xxs" data-confirm><div class="button__text">${translates.ok}</div></div>
                                    </div>
                                </form>
                            </div>
                        </div>`);

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');
            let confirm = editor.find('[data-confirm]');

            reset.click(() => {
                input.val('').trigger('change');
                btn.removeClass('is-filtered');
                confirm.trigger('click');
                prevVal = '';
            });

            confirm.on('click', () => {
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        let dates = input.val().split('-');
                        $el.filters.dateFrom = dates[0];
                        $el.filters.dateTo = dates[1];
                        btn.addClass('is-filtered').trigger('click');
                    } else {
                        delete $el.filters.dateFrom;
                        delete $el.filters.dateTo;
                        btn.removeClass('is-filtered').trigger('click');
                    }
                    prevVal = input.val();

                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })

            return editor.get(0);
        };

        let reclamationNumberEditor = function (cell, onRendered, success, cancel, editorParams) {
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form">
                                    <div class="form-item form-item--input form-item--theme-light _control-padding-xs _control-height-df _b-r-none">
                                        <div class="form-item__body">
                                            <input type="text" class="form-item__control">
                                            <label class="form-item__label">${translates.reclamationList.numberApplication}</label>
                                        </div>
                                    </div>
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-sm" data-reset><div class="button__text">${translates.reset}</div></div>
                                </form>
                            </div>
                        </div>`);
            let prevVal = '';

            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                input.val('');
                input.trigger('change');
                btn.removeClass('is-filtered');
                prevVal = '';
            });

            input.change(() => {
                btn.trigger('click');
                if (prevVal !== input.val()) {
                    if (input.val().length > 0) {
                        $el.filters.number = input.val();
                        btn.addClass('is-filtered');
                    } else {
                        delete $el.filters.number;
                        btn.removeClass('is-filtered');
                    }
                    prevVal = input.val();
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            });

            return editor.get(0);
        };

        let receiptsArchiveYearEditor = function (cell, onRendered, success, cancel, editorParams) {
            let prevVal = '';
            let editor = $(`<div class="dropdown js-import " data-dropdown>
                            <button class="button button--icon button--icon-md" data-dropdown-button data-filter>
                                <svg class="button__icon">
                                    <use xlink:href="#icon-filter"></use>
                                </svg>
                            </button>
                            <div class="dropdown__content dropdown__content--tabulator" data-dropdown-content>
                                <form class="js-import ajax-form _text-left">
                                    <div class="button button--theme-transparent _color-red _b-r-none button--size-sm" data-reset><div class="button__text">${translates.reset}</div></div>
                                    <ul class="dropdown-list" data-year-list>
                                    </ul>
                                </form>
                            </div>
                        </div>`);

            const $yearList = editor.find('[data-year-list]');
            let currentYear = new Date().getFullYear();
            let years = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];
            let yearsItem = years.map((item, index) => {
                return (`
                            <li id="${item}" class="year-list__item">
                                ${item}
                            </li>
                        `)
            });
            $yearList.html(yearsItem.join(''));


            let input = editor.find('input');
            let btn = editor.find('[data-dropdown-button]');

            input.on('keyup', function () {
                let value = $(this).val().toLowerCase();
                $yearList.find('li').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                });
            });

            $yearList.on('click', 'li', function () {
                let chosen = $(this);
                $yearList.find('li').removeClass('is-active');
                $el.filters.archiveYear = chosen.attr('id');
                chosen.addClass('is-active');
                btn.addClass('is-filtered').trigger('click');
                if (prevVal !== chosen.attr('id')) {
                    window.tableData = [];
                    showInfo();
                    prevVal = chosen.attr('id')
                    let page = getPage(tableType);
                    let size = getPageSize(tableType);
                    updateTable(1, size);
                }
            })
            let reset = editor.find('[data-reset]');

            reset.click(() => {
                $yearList.find('li').removeClass('is-active');
                delete $el.filters.archiveYear;
                btn.removeClass('is-filtered').trigger('click');
                let page = getPage(tableType);
                let size = getPageSize(tableType);
                updateTable(1, size);
                prevVal = '';
            });

            return editor.get(0);
        };

        const getTableHeader = new Promise((resolve, reject) => {
            $.ajax({
                url: headerUrl,
                type: 'post',
                data: {},
                success: (response) => {
                    resolve(response);
                },
                error: (response) => {
                    reject(response);
                }
            })
        });

        if (tableType === 'receipts' || tableType === 'archive') {
            if (url && headerUrl) {
                getTableHeader.then((response) => {
                    initTable(response);
                })
            }
        } else {
            initTable();
        }

        function toDelete(data) {
            $body.addClass('is-loading');
            if (data.length > 0) {
                let idCards = [];
                for (let card of data) {
                    idCards.push(card.id);
                }
                $.ajax({
                    url: GLOBAL_APP_PATH + window.currentLang + '/UserReceipts/DeactivateReceiptsList',
                    type: 'get',
                    data: {
                        receipts: idCards.join(',')
                    },
                    success: (response) => {
                        $tableToolbarButtons.attr('disabled', true);
                        if (response.status) {
                            notifier.success(response.message).then((noty) => {
                                noty.show();
                            });
                        } else {
                            notifier.error(response.message).then((noty) => {
                                noty.show();
                            });
                        }
                        table.replaceData();
                    }
                });
            }
        }

        function toArchive(data) {
            $body.addClass('is-loading');
            if (data.length > 0) {
                let actualCards = [];
                let excludedCards = [];
                for (let card of data) {
                    switch (card.status) {
                        case '0':
                        case '1':
                        case '8':
                            actualCards.push(card.id);
                            break;
                        default:
                            excludedCards.push(card.number);
                            break;
                    }
                }

                if (actualCards.length > 0) {
                    $.ajax({
                        url: '/api/Receipts/UpdateSendArchiveList',
                        type: 'get',
                        data: {
                            id: actualCards.join(',')
                        },
                        success: (response) => {
                            if (excludedCards.length === 0) {
                                const successMessage = actualCards.length > 1 ? translates.receiptMultipleMessage : translates.receiptSingleMessage;
                                $tableToolbarButtons.attr('disabled', true);
                                notifier.success(successMessage).then((noty) => {
                                    noty.show();
                                });
                            } else {
                                const errorMessage = excludedCards.length > 1 ? translates.receiptMultiple : translates.receiptSingle;
                                notifier.error(errorMessage + ' ' + excludedCards + ' ' + translates.receiptErrorMessage).then((noty) => {
                                    noty.show();
                                });
                            }
                            table.replaceData();
                        }
                    });
                } else {
                    const errorMessage = excludedCards.length > 1 ? translates.receiptMultiple : translates.receiptSingle;
                    notifier.error(errorMessage + ' ' + excludedCards + ' ' + translates.receiptErrorMessage).then((noty) => {
                        noty.show();
                    });
                }
            }
        }

        function removeFromArchive(id) {
            $body.addClass('is-loading');

            $.ajax({
                url: '/api/Receipts/UpdateSendArchive',
                type: 'get',
                data: {
                    id: id
                },
                success: (response) => {
                    notifier.success(translates.receiptToJournal).then((noty) => {
                        noty.show();
                    });
                    table.replaceData();
                }
            });
        }

        function showInfo() {
            const $wrapper = $('[data-table-data]');
            const $label = $wrapper.find('[data-label]');
            $label.toggleClass('_hide', window.tableData.length > 0);
            const $container = $wrapper.find('[data-table-data-container]');
            $container.toggleClass('_hide', window.tableData.length === 0);
            let data = [];
            let placesCount = 0,
                totalWeight = 0,
                volume = 0,
                cashOnDelivery = 0,
                insuranceCost = 0,
                discountCost = 0,
                transportCostWithAux = 0,
                declaredCost = 0,
                codComissionFloat = 0,
                totalCost = 0,
                receiptsSelected = window.tableData.length;

            for (let item of window.tableData) {
                placesCount += parseInt(item['countPlace']);
                totalWeight += item['forwarderWeight'];
                volume += item['forwarderSize'];
                cashOnDelivery += item['cashOnDelivery'];
                totalCost += item['totalCost'];
                codComissionFloat += item['codComissionFloat'];
                insuranceCost += item['insuranceCost'];
                discountCost += item['discountCost'];
                transportCostWithAux += item['transportCostWithAux'];
                declaredCost += item['declaredCost'];
            }
            data.push(
                [[translates.labelSelect + ':'], receiptsSelected + ' ' + translates.labelFrom + ' ' + window.totalReceiptsCount],
                [[translates.placesCountLabel + ':'], placesCount],
                [[translates.totalWeightLabel + ':'], totalWeight],
                [[translates.volumeLabel + ':'], volume.toFixed(3)],
                [[translates.cashOnDeliveryLabel + ', ' + translates.currency + ':'], cashOnDelivery],
                [[translates.codComissionLabel + ', ' + translates.currency + ':'], codComissionFloat],
                [[translates.insuranceCostLabel + ', ' + translates.currency + ':'], insuranceCost],
                [[translates.discountLabel + ', ' + translates.currency + ':'], discountCost],
                [[translates.transportCostLabel + ', ' + translates.currency + ':'], transportCostWithAux],
                [[translates.declaredCostLabel + ', ' + translates.currency + ':'], declaredCost],
            );
            let buttons = [];
            buttons = data.map((item) => {
                return (`<div class="_cell">
                    <div class="button button--border-yellow button--theme-ultra-light-yellow button--br-full button--size-xs button--icon button--icon-sm">
                            <span class="button__text">
                                ${item[0] + ' ' + item[1]}
                            </span>
                    </div>
                </div>`);
            });
            buttons.push(`<div class="_cell">
                <div class="button button--border-yellow button--theme-light-yellow button--br-full button--size-xs button--icon button--icon-sm">
                        <span class="button__text">
                            ${translates.totalLabel + ', ' + translates.currency + ':' + ' ' + totalCost}
                        </span>
                </div>
            </div>`);

            $container.html(buttons)
        }

        function initTable(response) {

            switch(tableType) {
                case 'receipts':
                    let sorters = {
                        'countPlace': 'number',
                        'forwarderWeight': 'number',
                        'forwarderSize': 'number',
                        'cost': 'number',
                        'cashOnDeliveryCost': 'number',
                        'lostFree': 'number',
                        'codComission': 'number',
                        'declaredCost': 'number',
                        'transportCostWithAux': 'number',
                        'insuranceCost': 'number',
                        'auxCost': 'number',
                        'discountCost': 'number',
                        'dateDeliveryPlan': 'date',
                        'dateSend': 'date',
                        'dateReceive': 'date',
                        'DateGivingOut': 'date',
                        'cashPayMentDate': 'date',
                        'createdOn': 'date',
                    };
                    let lastReceiptId = '';
                    let columns = [
                        {
                            formatter: "rowSelection",
                            title: translates['select'],
                            cssClass: "tabulator-checkbox-cell",
                            hozAlign: "center",
                            frozen: true,
                            headerSort: false,
                            cellClick: function (e, cell) {
                                cell.getRow().toggleSelect();
                            }
                        }
                    ];
                    for (let column of response) {
                        // if (column['InnerName'] === 'PartnerNumber') {
                        //     continue;
                        // }
                        columns.push({
                            title: column['Name'],
                            field: column['InnerName'] === 'status' ? 'statusesDecoding' : column['InnerName'],
                            frozen: column['InnerName'] === 'number' || column['InnerName'] === 'status',
                            headerFilter: eval(filters[column['InnerName']]),
                            headerFilterLiveFilter: false,
                            sorter: sorters[column['InnerName']] || 'string',
                            formatter: column['InnerName'] !== 'number' ? eval(formatters[column['InnerName']]) : 'link',
                            formatterParams: column['InnerName'] === 'number' ? {
                                url: function(cell) {
                                    return `${GLOBAL_APP_PATH}${window.currentLang}/Receipts/DetailsFull/${cell.getValue()}`
                                },
                                labelField: 'number',
                                target:"_blank"
                            } : {},
                            headerFilterParams: {initial: ''}
                        });
                        if (column['InnerName'] === 'status') {
                            columns.push({
                                title: 'statusInt',
                                field: 'status',
                                visible: false,
                                frozen: false
                            });
                        }
                    }

                    table = new Tabulator(el, {
                        placeholder: translates.noReceipts,
                        minHeight: 500,
                        columns: columns,
                        resizableColumns: false,
                        autoResize: false,
                        ajaxConfig: "post",
                        ajaxURL: url, //set url for ajax request
                        ajaxParams: Object.assign({
                            size: receiptPageSize,
                            page: receiptCurrentPage,
                            unpaidCOD: URLParamsSearch.get('unpaidCOD')

                        }, $el.filters),
                        downloadRowRange:"selected",
                        rowFormatter:function(row){
                            var data = row.getData();

                            let statusCell = row.getCell('status').getElement();
                            let statusDecodedCell = row.getCell('statusesDecoding').getElement()
                            let $number = $(row.getCell('number').getElement());
                            let $numberLink = $number.find('a');
                            if (data['Alias']) {
                                if ($numberLink.length) {
                                    $numberLink.text(data['Alias']);
                                } else {
                                    $number.text(data['Alias']);
                                }
                            }

                            if (data['CostStorage']) {
                                $(row.getCell('CostStorage').getElement()).addClass('text-block--red _text-center');
                            }
                            $number.css({'font-weight': '700', 'text-decoration': 'underline'});
                            switch(parseInt(data['status'], 10)) {
                                case 7:
                                case 0:
                                case 1:
                                    $(statusDecodedCell).css('color', '#87AF3F');
                                    break;
                                case 3:
                                case 4:
                                case 5:
                                    $(statusDecodedCell).css('color', '#FF5722');
                                    break;
                                case 6:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                    $(statusDecodedCell).css('color', '#F7C827');
                                    break;
                                case 2:
                                case 8:
                                    $(statusDecodedCell).css('color', '#999999');
                                    break;
                            }
                            if(data.id === lastReceiptId){
                                row.getElement().style.backgroundColor = "#FEF8DE";
                            }
                        },
                        rowSelected: function (row) {
                            window.tableData = table.getSelectedData();
                            $selectAll.prop('checked', table.getData().length === table.getSelectedData().length);
                            toggleDisabledButtons();
                            showInfo();
                        },
                        rowDeselected: function (row) {
                            window.tableData = table.getSelectedData();
                            $selectAll.prop('checked', table.getData().length === table.getSelectedData().length);
                            toggleDisabledButtons();
                            showInfo();
                        },
                        ajaxResponse: function (url, params, response) {
                            window.totalReceiptsCount = response.records;
                            $selectAll.prop('checked', false);
                            $body.removeClass('is-loading');
                            isFilter();
                            lastReceiptId = response.lastReceiptId;
                            if (response.rows.length === 0) {
                                table.setData([]);
                                table.redraw();
                            }
                            receiptCurrentPage = paginate(response.records, receiptPageSize, receiptCurrentPage, receiptTotalPages);

                            setTimeout(function () {
                                table.redraw();
                            }, 200);
                            return response.rows;
                        },
                        tableBuilt: function () {
                            setTimeout(function () {
                                $(window).resize(function () {
                                    setTimeout(function () {
                                        $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                                    }, 100);
                                });
                                $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());

                                $(".tabulator-tableHolder").scroll(function () {
                                        $(".tabulator-scrollWrapper")
                                            .scrollLeft($(".tabulator-tableHolder").scrollLeft());
                                });
                                $(".tabulator-scrollWrapper").scroll(function () {
                                        $(".tabulator-tableHolder")
                                            .scrollLeft($(".tabulator-scrollWrapper").scrollLeft());
                                });
                                reInitScripts($('.tabulator-header').get(0));
                            }, 100);
                        },
                        downloadReady: function (fileContents, blob) {
                            $body.removeClass('is-loading');

                            return blob;
                        },
                        dataLoading:function(data){
                            data.forEach((item, index) => {
                                item['lostFree'] = item['lostFree'] < 0 ? 0 : item['lostFree'];
                            });
                        },
                        dataLoaded: function (data) {
                            $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                        }
                    });

                    $('[data-page-sizer]').on('change.select2', function (e) {
                        const $this = $(e.target);
                        const val = $this.val();
                        const oldPageSize = receiptPageSize;
                        receiptPageSize = parseInt($this.val());
                        receiptCurrentPage = Math.ceil((oldPageSize * (receiptCurrentPage - 1) + 1) / receiptPageSize);

                        cookieData.add('receiptSize', val, {expires: 3600 * 24 * 180, path: '/'});
                        updateTable(receiptCurrentPage, receiptPageSize);
                    });
                    $(document).on('click', '[data-page]', function () {
                        const $this = $(this);
                        const page = $this.data('page');

                        if ($this.hasClass('disabled')) {
                            return false;
                        }

                        if (page === 'prev') {
                            receiptCurrentPage -= 1;
                        } else if (page === 'next') {
                            receiptCurrentPage += 1;
                        } else {
                            receiptCurrentPage = page;
                        }

                        updateTable(receiptCurrentPage, receiptPageSize);
                    });
                    $selectAll.click(() => {
                        if (table.getData().length !== table.getSelectedData().length) {
                            table.selectRow();
                        } else {
                            table.deselectRow();
                        }
                        window.tableData = table.getSelectedData();
                        toggleDisabledButtons();
                        showInfo();
                    });
                    $exportExcel.click(() => {
                        exportExcel();
                    });
                    $print.click((event) => {
                        const data = table.getSelectedData();
                        const type = $(event.target).data('print');
                        let finalData = [];
                        data.forEach((item, index) => {
                            finalData.push(item['id']);
                        });
                        print(finalData, type);
                    });
                    $printRegistered.click(() => {
                        const data = table.getSelectedData();
                        let finalData = [];
                        data.forEach((item, index) => {
                            finalData.push(item['id']);
                        });
                        printRegistered(finalData);
                    });
                    $toArchive.click(() => {
                        toArchive(table.getSelectedData());
                    });
                    $toDelete.click(() => {
                        window.magnificPopup.close();
                        toDelete(table.getSelectedData());
                    });
                    break;
                case 'archive':
                    let archiveSorters = {
                        'countPlace': 'number',
                        'forwarderWeight': 'number',
                        'forwarderSize': 'number',
                        'cost': 'number',
                        'cashOnDeliveryCost': 'number',
                        'lostFree': 'number',
                        'codComission': 'number',
                        'declaredCost': 'number',
                        'transportCostWithAux': 'number',
                        'insuranceCost': 'number',
                        'auxCost': 'number',
                        'discountCost': 'number',
                        'dateDeliveryPlan': 'date',
                        'dateSend': 'date',
                        'dateReceive': 'date',
                        'DateGivingOut': 'date',
                        'cashPayMentDate': 'date',
                        'createdOn': 'date',
                    };
                    let archiveColumns = [
                        {
                            formatter: "rowSelection",
                            title: translates['select'],
                            cssClass: "tabulator-checkbox-cell",
                            hozAlign: "center",
                            frozen: true,
                            headerSort: false,
                            cellClick: function (e, cell) {
                                cell.getRow().toggleSelect();
                            }
                        },{
                            title: translates.returnToJournal,
                            frozen: true,
                            headerSort: false,
                            formatter: function(cell, formatterParams, onRendered) {
                                const row = cell.getRow();
                                const data = row.getData();
                                return `<div
                                   class="button button--theme-yellow button--size-xs button--border-yellow button--br-df" ${!data['IsArchive'] ? 'disabled' : ''} data-return-from-archive="${data.id}">
                                            <span class="button__text">
                                                ${translates.return}
                                            </span>
                                </div>`
                            }
                        },

                    ];
                    for (let column of response) {
                        // if (column['InnerName'] === 'PartnerNumber') {
                        //     continue;
                        // }
                        archiveColumns.push({
                            title: column['Name'],
                            field: column['InnerName'] === 'status' ? 'statusesDecoding' : column['InnerName'],
                            frozen: column['InnerName'] === 'number' || column['InnerName'] === 'status',
                            headerFilter: eval(filters[column['InnerName']]),
                            headerFilterLiveFilter: false,
                            sorter: archiveSorters[column['InnerName']] || 'string',
                            formatter: column['InnerName'] !== 'number' ? eval(formatters[column['InnerName']]) : 'link',
                            formatterParams: column['InnerName'] === 'number' ? {
                                url: function(cell) {
                                    return `${GLOBAL_APP_PATH}${window.currentLang}/Receipts/DetailsFull/${cell.getValue()}`
                                },
                                labelField: 'number',
                                target:"_blank"
                            } : {},
                            headerFilterParams: {initial: ''}
                        });
                        if (column['InnerName'] === 'status') {
                            archiveColumns.push({
                                title: 'statusInt',
                                field: 'status',
                                visible: false,
                                frozen: false
                            });
                        }
                    }

                    table = new Tabulator(el, {
                        placeholder: translates.noReceipts,
                        minHeight: 500,
                        columns: archiveColumns,
                        resizableColumns: false,
                        ajaxConfig: "post",
                        ajaxURL: url, //set url for ajax request
                        ajaxParams: Object.assign({
                            size: archivePageSize,
                            page: archiveCurrentPage
                        }, $el.filters),
                        rowFormatter:function(row){
                            var data = row.getData();
                            let statusCell = row.getCell('status').getElement();
                            let statusDecodedCell = row.getCell('statusesDecoding').getElement()
                            let $number = $(row.getCell('number').getElement());
                            if (data['CostStorage']) {
                                $(row.getCell('CostStorage').getElement()).addClass('text-block--red _text-center');
                            }

                            $number.css({'font-weight': '700', 'text-decoration': 'underline'});
                            $(row.getCell('statusesDecoding').getElement()).css({'z-index': 4});
                            switch(parseInt(data['status'], 10)) {
                                case 7:
                                case 0:
                                case 1:
                                    $(statusDecodedCell).css('color', '#87AF3F');
                                    break;
                                case 3:
                                case 4:
                                case 5:
                                    $(statusDecodedCell).css('color', '#FF5722');
                                    break;
                                case 6:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                    $(statusDecodedCell).css('color', '#F7C827');
                                    break;
                                case 2:
                                case 8:
                                    $(statusDecodedCell).css('color', '#999999');
                                    break;
                            }
                        },
                        rowSelected: function (row) {
                            window.tableData = table.getSelectedData();
                            $selectAll.prop('checked', table.getData().length === table.getSelectedData().length);
                            toggleDisabledButtons();
                        },
                        rowDeselected: function (row) {
                            window.tableData = table.getSelectedData();
                            $selectAll.prop('checked', table.getData().length === table.getSelectedData().length);
                            toggleDisabledButtons();
                        },
                        ajaxResponse: function (url, params, response) {
                            window.totalReceiptsCount = response.records;
                            $selectAll.prop('checked', false);
                            $('.tabulator-paginator').addClass('paginator-loaded');
                            $body.removeClass('is-loading');
                            if (response.rows.length === 0) {
                                table.setData([]);
                                table.redraw();
                            }
                            archiveCurrentPage = paginate(response.records, archivePageSize, archiveCurrentPage, archiveTotalPages);
                            setTimeout(function () {
                                table.redraw();
                            }, 200);
                            return response.rows;
                        },
                        tableBuilt: function () {
                            setTimeout(function () {
                                $(window).resize(function () {
                                    setTimeout(function () {
                                        $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                                    }, 100);
                                });
                                $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());

                                $(".tabulator-tableHolder").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-scrollWrapper")
                                            .scrollLeft($(".tabulator-tableHolder").scrollLeft());
                                    }, 1)
                                });
                                $(".tabulator-scrollWrapper").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-tableHolder")
                                            .scrollLeft($(".tabulator-scrollWrapper").scrollLeft());
                                    }, 1)
                                });
                                reInitScripts($('.tabulator-header').get(0));
                            }, 100);
                        },
                        downloadReady: function (fileContents, blob) {
                            $body.removeClass('is-loading');

                            return blob;
                        },
                        dataLoaded: function () {
                            $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                        }
                    });

                    $('[data-page-sizer]').on('change.select2', function (e) {
                        const $this = $(e.target);
                        const val = $this.val();
                        const oldPageSize = archivePageSize;
                        archivePageSize = parseInt($this.val());
                        archiveCurrentPage = Math.ceil((oldPageSize * (archiveCurrentPage - 1) + 1) / archivePageSize);

                        cookieData.add('archiveSize', val, {expires: 3600 * 24 * 180, path: '/'});
                        updateTable(archiveCurrentPage, archivePageSize);
                    });
                    $(document).on('click', '[data-page]', function () {
                        const $this = $(this);
                        const page = $this.data('page');

                        if ($this.hasClass('disabled')) {
                            return false;
                        }

                        if (page === 'prev') {
                            archiveCurrentPage -= 1;
                        } else if (page === 'next') {
                            archiveCurrentPage += 1;
                        } else {
                            archiveCurrentPage = page;
                        }

                        updateTable(archiveCurrentPage, archivePageSize);
                    });
                    $selectAll.click(() => {
                        if (table.getData().length !== table.getSelectedData().length) {
                            table.selectRow();
                        } else {
                            table.deselectRow();
                        }
                        window.tableData = table.getSelectedData();
                        toggleDisabledButtons();
                        showInfo();
                    });
                    $exportExcel.click(() => {
                        $body.addClass('is-loading');
                        exportExcel();
                    });
                    $(document).on('click', '[data-return-from-archive]', function() {
                        let id = $(this).data('return-from-archive');
                        removeFromArchive(id);
                    })
                    break;
                case 'ordersList':
                    let lastAppId = '';

                    let orderListColumns = [
                        {
                            title: translates.ordersList['orderNumber'],
                            field: 'AppNumber',
                            headerFilter: ordersNumberEditor,
                            headerFilterLiveFilter: false,
                        },
                        {
                            title: translates.ordersList['orderState'],
                            field: 'AppStateStr',
                            headerFilter: ordersAppStateEditor,
                            headerFilterLiveFilter: false,
                        },
                        {
                            title: 'appState',
                            field: 'AppState',
                            visible: false
                        },
                        {
                            title: translates.ordersList['address'],
                            field: 'Address'
                        },
                        {
                            title: translates.ordersList['dateCreate'],
                            field: 'CreatedDate',
                            headerFilter: ordersDateCreateEditor,
                            headerFilterLiveFilter: false,
                        },
                        {
                            title: translates.ordersList['dateClose'],
                            field: 'ClosedDate'
                        },
                        {
                            title: translates.ordersList['requestType'],
                            field: 'PickDelivStr',
                            headerFilter: ordersAppTypeEditor,
                            headerFilterLiveFilter: false,
                            align: 'center'
                        },
                        {
                            visible: false,
                            title: 'pickDeliv',
                            field: 'PickDeliv',
                        },
                        {
                            title: translates.ordersList['actions'],
                            headerSort: false,
                            widthGrow: 1.9,
                            formatter: function(cell, formatterParams, onRendered) {
                                const row = cell.getRow();
                                const data = row.getData();
                                const number = row.getCell('AppNumber').getValue();
                                return (`
                                    <div class="_flex _items-center">
                                        <div data-download-order="${number}" class="button button--icon button--icon-md _mr-df _vw:mr-df _flex-noshrink" ${data['Receipts'].length > 0 ? '' : 'disabled'}>
                                            <svg class="button__icon">
                                                <use xlink:href="#download"></use>
                                            </svg>
                                        </div>
                                       <div data-cancel-order="${data['AppId']}" class="button button--theme-white button--size-sm button--border-yellow button--br-df _mr-df _vw:mr-df" ${!data['canCancelOrder'] || data['AppState'] === 100000000 ? 'disabled' : ''}>
                                            <span class="button__text">
                                                ${translates.cancel}
                                            </span>
                                        </div>
                                        <a href="${GLOBAL_APP_PATH}${window.currentLang}/SharedForms/CourierForm?appNumber=${number}" class="button button--theme-yellow button--size-sm button--border-yellow button--br-df" ${data['PickDeliv'] !== true ? '' : 'disabled'}>
                                            <span class="button__text">
                                                ${translates.pickupJournalRepeat}
                                            </span>
                                        </a>
                                    </div>
                                `);
                            }
                        },
                    ];
                    table = new Tabulator(el, {
                        minHeight: 500,
                        columns: orderListColumns,
                        resizableColumns: false,
                        placeholder: translates.noOrders,
                        autoResize: false,
                        layout: 'fitColumns',
                        ajaxConfig: "post",
                        ajaxURL: url,
                        ajaxParams: Object.assign({
                            size: ordersPageSize,
                            page: ordersCurrentPage
                        }, $el.filters),
                        downloadRowRange:"selected",
                        rowFormatter:function(row){
                            var data = row.getData();
                            let $number = $(row.getCell('AppNumber').getElement());
                            let $dateCreate = $(row.getCell('CreatedDate').getElement());
                            let $dateClose = $(row.getCell('ClosedDate').getElement());
                            let $address = $(row.getCell('Address').getElement());
                            $address.text(data['cityText'] + ', ' + data['addressText']);
                            $number.attr('data-mfp', 'inline').attr('data-mfp-src', '#orderListPopup').attr('data-detailed', data['AppNumber']).addClass('js-import');
                            $number.css({'font-weight': '700', 'text-decoration': 'underline', 'cursor': 'pointer'});
                            $dateCreate.css('font-weight', '700');
                            $dateClose.css('font-weight', '700');
                            const $status = $(row.getCell('AppStateStr').getElement());
                            const statusInt = row.getCell('AppState').getValue();

                            switch (parseInt(statusInt, 10)) {
                                case 100000000:
                                case 100000001:
                                    $status.css('color', '#999999');
                                    break;
                                case 100000002:
                                    $status.css('color', '#87AF3F')
                                    break;
                                case 100000003:
                                case 100000004:
                                case 100000005:
                                    $status.css('color', '#F7C827')
                                    break;
                                /*case 100000000:
                                    $status.css('color', '#219653');
                                    break;
                                case 100000001:
                                    $status.css('color', '#87AF3F');
                                    break;
                                case 100000002:
                                    $status.css('color', '#6B9FCE')
                                    break;
                                case 100000003:
                                    $status.css('color', '#FF5722')
                                    break;
                                case 100000004:
                                    $status.css('color', '#F7C827')
                                    break;
                                case 100000005:
                                    $status.css('color', '#6B9FCE')
                                    break;*/
                            }

                            if (data['cancelingInModeration']) {
                                $status.text(translates.moderating).css('color', '#FF5722');
                            }

                            if(data['AppId'] === lastAppId){
                                row.getElement().style.backgroundColor = "#FEF8DE";
                            }

                        },
                        ajaxResponse: function (url, params, response) {
                            $('.tabulator-paginator').addClass('paginator-loaded');
                            $body.removeClass('is-loading');
                            initialData = response.rows;
                            lastAppId = response['lastAppId'];
                            if (response.rows.length === 0) {
                                table.setData([]);
                                table.redraw();
                            } else {
                                ordersCurrentPage = paginate(response.records, ordersPageSize, ordersCurrentPage, ordersTotalPages);
                            }
                            setTimeout(function () {
                                table.redraw();
                            }, 200);
                            return response.rows;
                        },
                        dataLoading: function(data) {
                            data.forEach((item, index) => {
                                const dateCreate = item['CreatedDate'].replace(/[^0-9.]+/g,"");
                                let createdDate = new Date(parseInt(dateCreate, 10));
                                item['CreatedDate'] = createdDate.toLocaleDateString(window.currentLang);
                                if (item['ClosedDate'] !== null) {
                                    let dateClose = item['ClosedDate'].replace(/[^0-9.]+/g,"");
                                    let closedDate = new Date(parseInt(dateClose, 10));
                                    item['ClosedDate'] = closedDate.toLocaleDateString(window.currentLang);
                                }
                            });
                        },
                        dataLoaded: function(data) {
                            reInitScripts($('.tabulator-tableHolder').get(0));
                        },
                        tableBuilt: function () {
                            setTimeout(function () {
                                $(window).resize(function () {
                                    setTimeout(function () {
                                        $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                                    }, 100);
                                });
                                $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());

                                $(".tabulator-tableHolder").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-scrollWrapper")
                                            .scrollLeft($(".tabulator-tableHolder").scrollLeft());
                                    }, 1)
                                });
                                $(".tabulator-scrollWrapper").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-tableHolder")
                                            .scrollLeft($(".tabulator-scrollWrapper").scrollLeft());
                                    }, 1)
                                });
                                reInitScripts($('.tabulator-header').get(0));
                            }, 100);
                        },
                    });

                    let $orderDownload = $el.find('[data-download-order]');
                    $('[data-page-sizer]').on('change.select2', function (e) {
                        const $this = $(e.target);
                        const val = $this.val();
                        const oldPageSize = ordersPageSize;
                        ordersPageSize = parseInt($this.val());
                        ordersCurrentPage = Math.ceil((oldPageSize * (ordersCurrentPage - 1) + 1) / ordersPageSize);

                        cookieData.add('reclamationSize', val, {expires: 3600 * 24 * 180, path: '/'});
                        updateTable(ordersCurrentPage, ordersPageSize);
                    });
                    $(document).on('click', '[data-page]', function () {
                        const $this = $(this);
                        const page = $this.data('page');

                        if ($this.hasClass('disabled')) {
                            return false;
                        }

                        if (page === 'prev') {
                            ordersCurrentPage -= 1;
                        } else if (page === 'next') {
                            ordersCurrentPage += 1;
                        } else {
                            ordersCurrentPage = page;
                        }

                        updateTable(ordersCurrentPage, ordersPageSize);
                    });
                    $(document).on('click', '[data-download-order]', function() {
                        downloadOrder($(this).data('download-order'));
                    });

                    $(document).on('click', '[data-cancel-order]', function() {
                        cancelOrder($(this).data('cancel-order'));
                    });

                    $(document).on('click', '[data-detailed]', function() {
                        getOrderInfo($(this).data('detailed'));
                    })

                    break;
                case 'loyaltyList':
                    let loyaltyListColumns = [
                        {
                            title: translates.loyaltyList['company'],
                            field: 'siteName',
                            headerFilterLiveFilter: false,
                        },
                        {
                            title: translates.loyaltyList['receiptNumber'],
                            field: 'receiptNumber',
                        },
                        {
                            title: translates.loyaltyList['date'],
                            field: 'operationDate',
                            headerFilterLiveFilter: false,
                            formatter: function (cell) {
                                const val = cell.getValue();
                                const timestamp = /\((.*?)\)/.exec(val);
                                const date = new Date(parseInt(timestamp[1]));
                                return date.toLocaleDateString(localeRu);
                            },
                        },
                        {
                            title: translates.loyaltyList['description'],
                            field: 'subtypeProfitName',
                            headerSort: false,
                            widthGrow: 4,
                        },
                        {
                            title: translates.loyaltyList['count'],
                            field: 'score',
                            headerFilterLiveFilter: false,
                            cssClass: 'tabulator-score',
                            sorter: function (a, b, aRow, bRow) {
                                const $elementA = $(aRow.getElement()).find('[data-operation-type]');
                                const $elementB = $(bRow.getElement()).find('[data-operation-type]');
                                const typeA = parseInt($elementA.data('operation-type'));
                                const typeB = parseInt($elementB.data('operation-type'));
                                let valA = a;
                                let valB = b;

                                if (typeA === 100000001) {
                                    valA = a * (-1);
                                }

                                if (typeB === 100000001) {
                                    valB = b * (-1);
                                }

                                return valA - valB;
                            }
                        },
                    ];
                    const localeRu = 'ru-RU';
                    const $loyaltyAdd = $('[data-loyalty-add]');
                    const $loyaltyRemove = $('[data-loyalty-remove]');
                    const $loyaltyExportExcel = $('[data-lp-export-excel]');
                    const $loyaltyWrap = $wrapper.closest('[data-user-points]') || $wrapper;

                    let pageSize = cookieData.receive('loyaltySize') || 12;
                    let currentPage = 1;
                    let totalPages = 0;
                    let startDate = (new Date()).toLocaleDateString(localeRu);
                    let endDate = (new Date()).toLocaleDateString(localeRu);

                    $body.addClass('is-loading');
                    table = new Tabulator(el, {
                        minHeight: 200,
                        columns: loyaltyListColumns,
                        columnMinWidth: 150,
                        resizableColumns: false,
                        layout: 'fitColumns',
                        placeholder: translates.loyaltyList['dataEmpty'],
                        ajaxConfig: "post",
                        ajaxURL: url,
                        ajaxParams: {
                            page: currentPage,
                            rows: pageSize,
                            startDate,
                            endDate
                        },
                        ajaxResponse: function (url, params, response){
                            const data = response.data;

                            if (data.length) {
                                const initialAdd = parseInt(data[0].sumScoreCrediting);
                                const initialRemove = parseInt(data[0].sumScoreDebt);
                                let addSum = initialAdd.toLocaleString(localeRu);
                                let removeSum = initialRemove.toLocaleString(localeRu);

                                if (initialAdd > 0) {
                                    addSum = '+ ' + addSum;
                                }

                                if (initialRemove > 0) {
                                    removeSum = '- ' + removeSum;
                                }

                                $loyaltyAdd.text(addSum);
                                $loyaltyRemove.text(removeSum);

                                totalPages = data[0].totalPages;
                                currentPage = paginate(null, pageSize, currentPage, totalPages);
                            } else {
                                $('[data-paginator-wrapper]').addClass('_hide');
                                $loyaltyAdd.text(0);
                                $loyaltyRemove.text(0);
                            }

                            setTimeout(function () {
                                $body.removeClass('is-loading');
                            }, 100);

                            return response.data;
                        },
                        rowFormatter: function (row) {
                            const data = row.getData();
                            const $count = $(row.getCell('score').getElement());
                            const type = data['operationType'];
                            $count.attr('data-operation-type', type);
                            $count.html(`${data['score']}&nbsp;<span>${translates.loyaltyList['countLabel']}</span>`);
                        },
                        tableBuilt: function () {
                            setTimeout(() => {
                                const $datepicker = window.loyaltyDatepicker;

                                $datepicker.on('apply.daterangepicker', function (ev, picker) {
                                    startDate = picker.startDate.format('YYYY-MM-DD');
                                    endDate = picker.endDate.format('YYYY-MM-DD');
                                    updateLoyaltyTable();
                                });

                                $datepicker.on('show.daterangepicker', function () {
                                    $datepicker.closest('.form-item__body').addClass('is-open');
                                });

                                $datepicker.on('hide.daterangepicker', function () {
                                    $datepicker.closest('.form-item__body').removeClass('is-open');
                                });
                            }, 100);
                        },
                    });

                    $('[data-page-sizer]').on('change.select2', function (e) {
                        const $this = $(e.target);
                        const val = $this.val();
                        const oldPageSize = pageSize;
                        pageSize = parseInt($this.val());
                        currentPage = Math.ceil((oldPageSize * (currentPage - 1) + 1) / pageSize);

                        cookieData.add('loyaltySize', val, {expires: 3600 * 24 * 180, path: '/'});
                        updateLoyaltyTable();
                    });

                    $(document).on('click', '[data-page]', function () {
                        const $this = $(this);
                        const page = $this.data('page');

                        if ($this.hasClass('disabled')) {
                            return false;
                        }

                        if (page === 'prev') {
                            currentPage = currentPage - 1;
                        } else if (page === 'next') {
                            currentPage = currentPage + 1;
                        } else {
                            currentPage = page;
                        }

                        updateLoyaltyTable();
                    });

                    $(document).on('click', '[data-lp-export-excel]', function () {
                        let input = JSON.stringify({
                            page: currentPage,
                            rows: pageSize,
                            startDate,
                            endDate
                        });
                        exportLpExcel(input);
                    });

                    function updateLoyaltyTable () {
                        const sort = table.getSorters();
                        $body.addClass('is-loading');
                        table.setData(url, {
                            page: currentPage,
                            rows: pageSize,
                            startDate,
                            endDate
                        }, "post").then(() => {
                            table.setSort(sort);
                            $body.removeClass('is-loading');
                        });
                    }

                    break;
                case 'loyaltyOrganizations':
                    let tableData = window.model;
                    tableData = tableData.filter((item) => {
                        return item.isParent === false;
                    });
                    let loyaltyColumns = [
                        {
                            vertAlign: 'middle',
                            formatter: "rowSelection",
                            title: translates['select'],
                            cssClass: "tabulator-checkbox-cell",
                            hozAlign: "center",
                            frozen: true,
                            headerSort: false,
                            width: 90,
                            cellClick: function (e, cell) {
                                cell.getRow().toggleSelect();
                            }
                        },
                        {
                            vertAlign: 'middle',
                            headerSort: false,
                            title: translates2['AccessToPoints'],
                            width: 150,
                            formatter: function(cell, formatterParams, onRendered) {
                                const row = cell.getRow();
                                const data = row.getData();

                                return (`
                                    <div class="toggler">
                                        <input data-toggle-score ${data['DisableByHead'] ? 'checked' : ''} type="checkbox" class="toggler__control" name="allowScore_${data['LoyaltyBalanceId']}"
                                               id="economTarif_${data['LoyaltyBalanceId']}">
                                        <label class="toggler__checkmark" for="economTarif_${data['LoyaltyBalanceId']}"></label>
                                    </div>`);
                            }
                        },
                        {
                            vertAlign: 'middle',
                            title: translates2['DistribScoreOrgName'],
                            field: 'organizationName',
                            widthGrow: 1,
                            minWidth: 250,
                        },
                        {
                            vertAlign: 'middle',
                            title: translates2['AccountPoints'],
                            field: 'CurrentScore',
                            width: 150,
                        },
                        {
                            vertAlign: 'middle',
                            hozAlign: 'center',
                            headerHozAlign: 'center',
                            headerSort: false,
                            title: translates2['AddScore'],
                            width: 150,
                            formatter: function(cell, formatterParams, onRendered) {
                                const row = cell.getRow();
                                const data = row.getData();

                                return (`
                                    <div  data-score-amount="${data['LoyaltyBalanceId']}" class="form-item form-item--input form-item--color-black form-item--width-md form-item--theme-base-white _control-height-smd _control-padding-xs _b-r-sm">
                                        <div class="form-item__body">
                                            <input type="text" class="form-item__control js-import text-center text-bold" data-inputmask="'regex' : '^-?[0-9]{1,5}$'">
                                        </div>
                                    </div>`);
                            }
                        },
                    ];

                    $body.addClass('is-loading');
                    table = new Tabulator(el, {
                        minHeight: 500,
                        data: tableData,
                        columns: loyaltyColumns,
                        resizableColumns: false,
                        layout: 'fitColumns',
                        pagination: 'local',
                        paginationSize: 10,
                        paginationElement: $el.parents('[data-tabulator]').find('[data-table-pagination]').get(0),
                        paginationSizeSelector: [10, 25, 50, 100],
                        rowFormatter: function (row) {
                          let data = row.getData();
                            let $row = $(row.getElement());
                            let $points = $(row.getCell('CurrentScore').getElement());
                            $points.css('font-weight', '700');
                            $row.data('tabulatorData', data);
                            $row.attr('id', data['LoyaltyBalanceId']);
                        },
                        pageLoaded: function () {
                            reInitScripts($('.tabulator-tableHolder').get(0));
                        },
                        dataLoaded: function(data) {
                            reInitScripts($('.tabulator-tableHolder').get(0));
                        },
                        rowSelected: function (row) {
                            $selectAll.prop('checked', table.getData().length === table.getSelectedData().length);
                            checkSelectedData();
                        },
                        rowDeselected: function (row) {
                            $selectAll.prop('checked', table.getData().length === table.getSelectedData().length);
                            checkSelectedData();
                        },
                        tableBuilt: function () {
                            setTimeout(function () {
                                $(window).resize(function () {
                                    setTimeout(function () {
                                        $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                                    }, 100);
                                });
                                $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());

                                $(".tabulator-tableHolder").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-scrollWrapper")
                                            .scrollLeft($(".tabulator-tableHolder").scrollLeft());
                                    }, 1)
                                });
                                $(".tabulator-scrollWrapper").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-tableHolder")
                                            .scrollLeft($(".tabulator-scrollWrapper").scrollLeft());
                                    }, 1)
                                });
                                $paginator.find('select').wrap('<div></div>').addClass('form-item__control').parent().addClass('js-import form-item form-item--select2 js-import select2--custom select2--custom-small').attr('data-initialize-select2', '{"Factory": "DefaultSelect2", "settings": {"minimumResultsForSearch": -1, "placeholder": "", "dropdownCssClass": "select2__custom-dropdown select2__custom-dropdown--small"}}');
                                reInitScripts($paginator.get(0));
                                reInitScripts($('.tabulator-header').get(0));
                                $body.removeClass('is-loading');
                            }, 100);
                            $('.tabulator-paginator').addClass('paginator-loaded');
                        },
                    });
                    let rowData = {};
                    const $checker = $('#useScoreSelected');
                    const $button = $('[data-send-distrib-selected]');
                    let defaultCheckerVal = $checker.is(':checked');
                    let defaultButtonState = $button.is(':disabled');

                    $checker.change((event) => {
                        if($checker.is(':checked') !== defaultCheckerVal) {
                            setButtonState($button, true);
                        } else {
                            setButtonState($button, defaultButtonState);
                        }
                    });

                    $('[data-added-score]').change((event) => {
                       setButtonState($('[data-send-distrib-selected]'), event.target.value.length > 0);
                    });

                    $('[data-send-distrib-selected]').click(function() {
                       let initialData = table.getSelectedData();
                       loyaltyData = [];
                       initialData.forEach((item) => {
                           item['isChanged'] = false;
                           loyaltyData.push(item);
                           let newData = Object.assign({}, item);
                           let addedScore = !isNaN(parseInt($('[data-added-score]').val(), 10)) ? parseInt($('[data-added-score]').val(), 10) : 0;
                           let allowScore = $('#useScoreSelected').is(':checked');
                           newData['isChanged'] = true;
                           newData['addedScore'] = addedScore;
                           newData['myDisableByHead'] = allowScore;
                           loyaltyData.push(newData);
                       });
                        let parentOrganization = window.model.filter((item) => {
                            return item.isParent === true;
                        });
                        loyaltyData.push(parentOrganization[0]);
                        $body.addClass('is-loading');

                        $.ajax({
                            url: GLOBAL_APP_PATH + window.currentLang + '/LoyaltyProgram/SendDistributionScore',
                            type: 'post',
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify({'model': loyaltyData}),
                            success: (response) => {
                                switch (response.status) {
                                    case 'ok':
                                        notifier.success(translates.scoreDistributed).then((noty) => {
                                            noty.show();
                                        });
                                        window.location.reload();
                                        break;
                                    case 'error':
                                        notifier.error(response.message).then((noty) => {
                                            noty.show();
                                        });
                                        break;
                                }
                            }
                        }).always(() => {
                            $body.removeClass('is-loading');
                        });
                    });

                    $('#scoreUsage').change(function() {
                        let parentOrganization = window.model.filter((item) => {
                            return item.isParent === true;
                        });
                        let data = parentOrganization[0];

                        data['isChanged'] = true;
                        data['myDisableByHead'] = $(this).is(':checked');
                        $body.addClass('is-loading');
                        const $button = $('[data-send-distrib-request]');
                        setButtonState($button, loyaltyData.length > 0 && $('#scoreUsage').is(':checked'));

                        $.ajax({
                            url: GLOBAL_APP_PATH + window.currentLang + '/LoyaltyProgram/SendDistributionScore',
                            type: 'post',
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify({'model': [data]}),
                            success: (response) => {
                                switch (response.status) {
                                    case 'error':
                                        notifier.error(response.message).then((noty) => {
                                            noty.show();
                                        });
                                        break;
                                }
                            }
                        }).always(() => {
                            $body.removeClass('is-loading');
                        });
                    })

                    $('[data-send-distrib-request]').click(function() {
                        $body.addClass('is-loading');

                        $.ajax({
                            url: GLOBAL_APP_PATH + window.currentLang + '/LoyaltyProgram/SendDistributionScore',
                            type: 'post',
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify({'model': loyaltyData}),
                            success: (response) => {
                                switch (response.status) {
                                    case 'ok':
                                        notifier.success(translates.scoreDistributed).then((noty) => {
                                            noty.show();
                                        });
                                        window.location.reload();
                                        break;
                                    case 'error':
                                        notifier.error(response.message).then((noty) => {
                                            noty.show();
                                        });
                                        break;
                                }
                            }
                        }).always(() => {
                            $body.removeClass('is-loading');
                        });
                    })

                    $(document).on('change', '[data-toggle-score]', function () {
                        const $toggler = $(this);
                        const $row = $toggler.parents('.tabulator-row');
                        let tableData = $row.data('tabulatorData');
                        let $item = $row.find('[data-score-amount] input');

                        if ($toggler.is(':checked') !== tableData['DisableByHead']) {
                            rowData[tableData['LoyaltyBalanceId']] = tableData;
                        } else {
                            if (!($item.val().length > 0 && parseInt($item.val(), 10) !== 0)) {
                                delete rowData[tableData['LoyaltyBalanceId']];
                            }
                        }
                        processFinalData(rowData);
                    });

                    $(document).on('change', '[data-score-amount] input',function () {
                        const $item = $(this);
                        const $row = $item.parents('.tabulator-row');
                        let tableData = $row.data('tabulatorData');
                        let $toggler = $row.find('[data-toggle-score]');

                        if (!rowData.hasOwnProperty(tableData['LoyaltyBalanceId']) && $item.val().length > 0 && parseInt($item.val(), 10) !== 0) {
                            rowData[tableData['LoyaltyBalanceId']] = tableData;
                        } else {
                            if ($toggler.is(':checked') === tableData['DisableByHead']) {
                                delete rowData[tableData['LoyaltyBalanceId']];
                            }
                        }
                        processFinalData(rowData);
                    });

                    $selectAll.click(() => {
                        if (table.getRows("visible").length !== table.getSelectedData().length) {
                            table.selectRow("visible");
                        } else {
                            table.deselectRow();
                        }
                        checkSelectedData();
                    });
                    break;
                case 'reclamationList':
                    let reclamationListColumns = [
                        {
                            title: translates.reclamationList['orderNumber'],
                            field: 'investigationName',
                            headerFilter: reclamationNumberEditor,
                            headerFilterLiveFilter: false,
                            frozen: true,
                            minWidth: 170,
                        },
                        {
                            title: translates.reclamationList['state'],
                            field: 'stateName',
                            headerFilter: reclamationDecisionNameEditor,
                            headerFilterLiveFilter: false,
                            frozen: true,
                            minWidth: 170,
                        },
                        {
                            title: 'state',
                            field: 'state',
                            visible: false
                        },
                        {
                            title: translates.reclamationList['decision'],
                            field: 'decisionName',
                            minWidth: 200,
                        },
                        {
                            title: 'decision',
                            field: 'decision',
                            visible: false
                        },
                        {
                            title: translates.reclamationList['dateFixation'],
                            field: 'registrationDate',
                            headerFilter: reclamationDateCreateEditor,
                            headerFilterLiveFilter: false,
                            minWidth: 200,
                        },
                        {
                            title: translates.reclamationList['dateOfConsideration'],
                            field: 'termOfApproval',
                            minWidth: 220,
                        },
                        {
                            title: '№ ТТН',
                            field: 'receiptName',
                            minWidth: 150,
                        },
                        {
                            title: translates.reclamationList['problemType'],
                            field: 'problemTypeName',
                            headerFilter: '',
                            headerFilterLiveFilter: false,
                            minWidth: 200,
                        },
                        {
                            title: translates.reclamationList['problem'],
                            field: 'description',
                            headerSort: false,
                            minWidth: 200,
                        },
                        {
                            title: translates.reclamationList['claimedAmountOfDamage'],
                            field: 'declaredCost',
                            hozAlign: "right",
                            minWidth: 200,
                        },
                        {
                            title: translates.reclamationList['agreedRefundAmount'],
                            field: 'costForReturn',
                            hozAlign: "right",
                            minWidth: 220,
                        },
                        {
                            title: translates.reclamationList['responsibleWorker'],
                            field: 'employeeName',
                            headerSort: false,
                            minWidth: 200,
                        },
                        {
                            title: translates.reclamationList['responsiblePhone'],
                            field: 'employeePhone',
                            headerSort: false,
                            minWidth: 170,
                        },
                        {
                            title: translates.reclamationList['responsibleEmail'],
                            field: 'employeeEmail',
                            headerSort: false,
                            formatter: 'link',
                            formatterParams: {
                                urlPrefix : 'mailto:'
                            },
                            minWidth: 170,
                        },
                        {
                            title: translates.reclamationList['dateTransferInsurance'],
                            field: 'dateToInsurance',
                            minWidth: 200,
                        },
                        {
                            title: translates.reclamationList['reimbursementDate'],
                            field: 'dateOfCompensation',
                            minWidth: 170,
                        },
                    ];
                    table = new Tabulator(el, {
                        minHeight: 500,
                        columns: reclamationListColumns,
                        resizableColumns: false,
                        placeholder: translates.reclamationList['officeInvestigationsNotFound'],
                        autoResize: false,
                        layout: 'fitColumns',
                        ajaxConfig: "post",
                        ajaxURL: url,
                        ajaxParams: Object.assign({
                            number: '',
                            state: ''
                        }, $el.filters),

                        rowFormatter:function(row){
                            var data = row.getData();
                            let $number = $(row.getCell('investigationName').getElement());
                            let $email = $(row.getCell('employeeEmail').getElement());
                            let $termOfApproval = $(row.getCell('termOfApproval').getElement());
                            $number.attr('data-mfp', 'inline').attr('data-mfp-src', '#reclamationPopup').attr('data-info', data['investigationName']).addClass('js-import');
                            $number.css({'font-weight': '700', 'text-decoration': 'underline', 'cursor': 'pointer'});
                            $email.css({'text-decoration': 'underline'});
                            $termOfApproval.css('font-weight', '600');
                            const statusInt = row.getCell('state').getValue();
                            const $status = $(row.getCell('stateName').getElement());
                            const $decision = $(row.getCell('decisionName').getElement());
                            switch(parseInt(statusInt, 10)){
                                case 100000000:
                                    $status.css('color', '#219653');
                                    $decision.css('color', '#219653');
                                    break;
                                case 100000001:
                                    $status.css('color', '#FF5722');
                                    $decision.css('color', '#FF5722');
                                    break;
                                case 100000002:
                                    $status.css('color', '#219653');
                                    $decision.css('color', '#219653');
                                    break;
                                case 100000003:
                                    $status.css('color', '#F0A443');
                                    $decision.css('color', '#F0A443');
                                    break;
                                case 100000004:
                                    $status.css('color', '#219653');
                                    $decision.css('color', '#219653');
                                    break;
                                case 100000005:
                                    $status.css('color', '#219653');
                                    $decision.css('color', '#219653');
                                    break;
                                default:
                                    $status.css('color', '#219653');
                                    $decision.css('color', '#219653');
                            }
                        },
                        ajaxResponse: function (url, params, response) {
                            $('.tabulator-paginator').addClass('paginator-loaded');
                            $body.removeClass('is-loading');
                            initialData = response.data;
                            if (response.data.length === 0) {
                                table.setData([]);
                                table.redraw();
                            } else {
                                $('[data-reclam-export]').removeClass('disabled');
                                reclamationCurrentPage = paginate(10, reclamationPageSize, reclamationCurrentPage, reclamationTotalPages);
                            }
                            setTimeout(function () {
                                table.redraw();
                            }, 200);
                            return response.data;
                        },
                        dataLoading: function(data) {
                            data.forEach((item, index) => {
                                const registrationDate = item['registrationDate'].replace(/[^0-9.]+/g,"");
                                let $registrationData = new Date(parseInt(registrationDate, 10));
                                item['registrationDate'] = $registrationData.toLocaleDateString(window.currentLang);
                                let termOfApproval = item['termOfApproval'].replace(/[^0-9.]+/g,"");
                                let $termOfApproval = new Date(parseInt(termOfApproval, 10));
                                item['termOfApproval'] = $termOfApproval.toLocaleDateString(window.currentLang);
                                if(item['dateOfCompensation'] !== null) {
                                    let dateOfCompensation = item['dateOfCompensation'].replace(/[^0-9.]+/g,"");
                                    let $dateOfCompensation = new Date(parseInt(dateOfCompensation, 10));
                                    item['dateOfCompensation'] = $dateOfCompensation.toLocaleDateString(window.currentLang);
                                }
                                if(item['dateToInsurance'] !== null) {
                                    let dateToInsurance = item['dateToInsurance'].replace(/[^0-9.]+/g,"");
                                    let $dateToInsurance = new Date(parseInt(dateToInsurance, 10));
                                    item['dateToInsurance'] = $dateToInsurance.toLocaleDateString(window.currentLang);
                                }
                                if(item['costForReturn'] === null) {
                                    item['costForReturn'] = '0';
                                }
                            });
                        },
                        dataLoaded: function (data) {
                            $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                            reInitScripts($('.tabulator-tableHolder').get(0));
                        },
                        tableBuilt: function () {
                            setTimeout(function () {
                                $(window).resize(function () {
                                    setTimeout(function () {
                                        $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                                    }, 100);
                                });
                                $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());

                                $(".tabulator-tableHolder").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-scrollWrapper")
                                            .scrollLeft($(".tabulator-tableHolder").scrollLeft());
                                    }, 1)
                                });
                                $(".tabulator-scrollWrapper").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-tableHolder")
                                            .scrollLeft($(".tabulator-scrollWrapper").scrollLeft());
                                    }, 1)
                                });
                                reInitScripts($('.tabulator-header').get(0));
                            }, 100);
                        },
                    });

                    $('[data-page-sizer]').on('change.select2', function (e) {
                        const $this = $(e.target);
                        const val = $this.val();
                        const oldPageSize = reclamationPageSize;
                        reclamationPageSize = parseInt($this.val());
                        reclamationCurrentPage = Math.ceil((oldPageSize * (reclamationCurrentPage - 1) + 1) / reclamationPageSize);

                        cookieData.add('reclamationSize', val, {expires: 3600 * 24 * 180, path: '/'});
                        updateTable(reclamationCurrentPage, reclamationPageSize);
                    });

                    $(document).on('click', '[data-page]', function () {
                        const $this = $(this);
                        const page = $this.data('page');

                        if ($this.hasClass('disabled')) {
                            return false;
                        }

                        if (page === 'prev') {
                            reclamationCurrentPage -= 1;
                        } else if (page === 'next') {
                            reclamationCurrentPage += 1;
                        } else {
                            reclamationCurrentPage = page;
                        }
                        updateTable(reclamationCurrentPage, reclamationPageSize);
                    });

                    $(document).on('click', '[data-info]', function () {
                        getReclamationInfo($(this).data('info'));
                    });

                    $(document).on('click', '[data-reclam-export]', function () {
                        table.download('xlsx', 'reclamation.xlsx');
                    });

                    break;
                case 'unpaidReceipts':
                    let unpaidColumns = [
                        {
                            formatter: "rowSelection",
                            title: translates['select'],
                            cssClass: "tabulator-checkbox-cell",
                            hozAlign: "center",
                            frozen: true,
                            headerSort: false,
                            cellClick: function (e, cell) {
                                cell.getRow().toggleSelect();
                            }
                        },
                        {
                            title: translates.unpaidReceipts['receiptNumber'],
                            field: 'number',
                            frozen: true,
                            sorter: 'string',
                            formatter: 'link',
                            formatterParams: {
                                url: function(cell) {
                                    return `${GLOBAL_APP_PATH}${window.currentLang}/Receipts/DetailsFull/${cell.getValue()}`
                                },
                                labelField: 'number',
                                target:"_blank"
                            },
                        },
                        {
                            title: translates.departureDate,
                            field: 'sendDate',
                            formatter: eval(formatters['date'])
                        },
                        {
                            title: translates.unpaidReceipts.arrivalDate,
                            field: 'receiveDate',
                            formatter: eval(formatters['date'])
                        },
                        {
                            title: translates.sendWarehouse,
                            field: 'dispatchingWarehouse',
                            sorter: 'string',
                            formatter: eval(formatters['dispatchingWarehouse'])
                        },
                        {
                            title: translates.receiveWarehouse,
                            field: 'receivingStore',
                            sorter: 'string',
                            formatter: eval(formatters['receivingStore'])
                        },
                        {
                            title: translates.unpaidReceipts.tey,
                            field: 'cost',
                            sorter: 'number',
                            formatter: eval(formatters['cost'])
                        },
                        {
                            title: translates.unpaidReceipts.teyStatus,
                            field: 'paymentStatus',
                            headerFilter: eval(filters['teyStatus']),
                            headerFilterLiveFilter: false,
                            headerFilterParams: {initial: ''},
                            sorter: 'string',
                            formatter: eval(formatters['paymentStatus'])
                        },
                        {
                            title: translates.unpaidReceipts.insurance,
                            field: 'insuranceCost',
                            sorter: 'number',
                            formatter: eval(formatters['insuranceCost'])
                        },
                        {
                            title: translates.unpaidReceipts.insuranceStatus,
                            field: 'insurancePaymentStatus',
                            headerFilter: eval(filters['insurancePaymentStatus']),
                            headerFilterLiveFilter: false,
                            headerFilterParams: {initial: ''},
                            sorter: 'string',
                            formatter: eval(formatters['paymentStatus'])
                        },
                        {
                            title: translates.unpaidReceipts.receiverCardNumber,
                            field: 'cardNumber',
                            sorter: 'string',
                            formatter: eval(formatters['cardNumber'])
                        },
                        {
                            title: translates.unpaidReceipts.cashOnDeliveryNumber,
                            field: 'insuranceNumber',
                            sorter: 'number',
                            formatter: eval(formatters['insuranceNumber'])
                        },
                        {
                            title: translates.unpaidReceipts.costOnDelivery,
                            field: 'cashOnDeliveryCost',
                            sorter: 'number',
                            formatter: eval(formatters['cashOnDeliveryCost'])
                        },
                        {
                            title: translates.unpaidReceipts.costOnDeliveryStatus,
                            field: 'cashOnDeliveryPaymentStatus',
                            headerFilter: eval(filters['cashOnDeliveryPaymentStatus']),
                            headerFilterLiveFilter: false,
                            headerFilterParams: {initial: ''},
                            sorter: 'string',
                            formatter: eval(formatters['paymentStatus'])
                        },
                        {
                            title: translates.unpaidReceipts.lockShipping,
                            field: 'LockShipping',
                            sorter: 'number',
                            formatter: eval(formatters['LockShipping'])
                        },
                    ];

                    table = new Tabulator(el, {
                        placeholder: translates.noReceipts,
                        minHeight: 500,
                        columns: unpaidColumns,
                        resizableColumns: false,
                        autoResize: false,
                        ajaxConfig: "post",
                        ajaxURL: url,
                        ajaxParams: Object.assign({
                            page: unpaidReceiptsCurrentPage,
                            rows: unpaidReceiptsPageSize,
                            receiptsId: JSON.stringify(unpaidReceiptsIds),
                            culture: window.currentLang
                        }, $el.filters),
                        downloadRowRange: "selected",
                        rowFormatter: function (row) {
                            const data = row.getData();

                            let $number = $(row.getCell('number').getElement());
                            let $numberLink = $number.find('a');
                            if (data['Alias']) {
                                if ($numberLink.length) {
                                    $numberLink.text(data['Alias']);
                                } else {
                                    $number.text(data['Alias']);
                                }
                            }
                            $number.css({'font-weight': '700', 'text-decoration': 'underline'});
                        },
                        rowSelected: function (row) {
                            const data = row.getData();
                            selectUnpaidReceipts(data);
                            toggleUnpaidReceiptsButtons();
                            setTotalPrice();
                        },
                        rowDeselected: function (row) {
                            const data = row.getData();
                            deselectUnpaidReceipts(data);
                            toggleUnpaidReceiptsButtons();
                            setTotalPrice();
                        },
                        ajaxResponse: function (url, params, response) {
                            $selectAll.prop('checked', false);
                            $body.removeClass('is-loading');
                            unpaidReceiptsSelected.tey = [];
                            unpaidReceiptsSelected.insurance = [];
                            toggleUnpaidReceiptsButtons();

                            if (response.rows.length === 0) {
                                table.setData([]);
                                table.redraw();
                            }
                            unpaidReceiptsCurrentPage = paginate(response.records, unpaidReceiptsPageSize, unpaidReceiptsCurrentPage, unpaidReceiptsTotalPages);

                            setTimeout(function () {
                                table.redraw();
                            }, 200);

                            return response.rows;
                        },
                        tableBuilt: function () {
                            setTimeout(function () {
                                $(window).resize(function () {
                                    setTimeout(function () {
                                        $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                                    }, 100);
                                });
                                $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());

                                $(".tabulator-tableHolder").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-scrollWrapper")
                                            .scrollLeft($(".tabulator-tableHolder").scrollLeft());
                                    }, 1)
                                });
                                $(".tabulator-scrollWrapper").scroll(function () {
                                    setTimeout(function () {
                                        $(".tabulator-tableHolder")
                                            .scrollLeft($(".tabulator-scrollWrapper").scrollLeft());
                                    }, 1)
                                });
                                reInitScripts($('.tabulator-header').get(0));
                            }, 100);
                        },
                        downloadReady: function (fileContents, blob) {
                            $body.removeClass('is-loading');
                            return blob;
                        },
                        dataLoaded: function (data) {
                            $('.tabulator-scroll').width($el.find('.tabulator-table').outerWidth());
                        }
                    });

                    $('[data-page-sizer]').on('change.select2', function (e) {
                        const $this = $(e.target);
                        const val = $this.val();
                        const oldPageSize = unpaidReceiptsPageSize;
                        unpaidReceiptsPageSize = parseInt($this.val());
                        unpaidReceiptsCurrentPage = Math.ceil((oldPageSize * (unpaidReceiptsCurrentPage - 1) + 1) / unpaidReceiptsPageSize);

                        cookieData.add('receiptSize', val, {expires: 3600 * 24 * 180, path: '/'});
                        updateTable(unpaidReceiptsCurrentPage, unpaidReceiptsPageSize, 'rows', true);
                    });

                    $(document).on('click', '[data-page]', function () {
                        const $this = $(this);
                        const page = $this.data('page');

                        if ($this.hasClass('disabled')) {
                            return false;
                        }

                        if (page === 'prev') {
                            unpaidReceiptsCurrentPage -= 1;
                        } else if (page === 'next') {
                            unpaidReceiptsCurrentPage += 1;
                        } else {
                            unpaidReceiptsCurrentPage = page;
                        }

                        updateTable(unpaidReceiptsCurrentPage, unpaidReceiptsPageSize, 'rows', true);
                    });

                    $selectAll.click(() => {
                        const allData = table.getData();
                        const selectedData = table.getSelectedData();

                        $.each(allData, (i, el) => {
                            if (allData.length !== selectedData.length) {
                                table.selectRow();
                                selectUnpaidReceipts(el);
                            } else {
                                table.deselectRow();
                                deselectUnpaidReceipts(el);
                            }
                        });

                        toggleUnpaidReceiptsButtons();
                        setTotalPrice();
                    });

                    $payTeyButton.on('click', () => {
                       payUnpaidReceipts(unpaidReceiptsSelected.tey, 0);
                    });

                    $payInsuranceButton.on('click', () => {
                        payUnpaidReceipts(unpaidReceiptsSelected.insurance, 1);
                    });

                    break;
            }
        }

        function setTotalPrice() {
            let data = table.getSelectedData();

            let TEUPrice = 0,
                insurancePrice = 0;

            data.forEach((item) => {
                insurancePrice += item['cashOnDeliveryCostValue'];
                TEUPrice += item['costValue'];
            });


            if (insurancePrice !== 0) {
                $payInsuranceButton.find('[data-price]').removeClass('_hide');
                $payInsuranceButton.find('[data-price] [data-value]').text(insurancePrice);
            } else {
                $payInsuranceButton.find('[data-price]').addClass('_hide');
            }

            if (TEUPrice !== 0) {
                $payTeyButton.find('[data-price]').removeClass('_hide');
                $payTeyButton.find('[data-price] [data-value]').text(TEUPrice);
            } else {
                $payTeyButton.find('[data-price]').addClass('_hide');
            }
        }

        function updateTable (currentPage, pageSize, sizeLabel = 'size', unpaidReceipts = false) {
            const sort = table.getSorters();
            $body.addClass('is-loading');
            table.setData(url,
                Object.assign({
                    page: currentPage,
                    [sizeLabel]: pageSize,
                    ...(unpaidReceipts && {receiptsId: JSON.stringify(unpaidReceiptsIds)}),
                    ...(unpaidReceipts && {culture: window.currentLang})
                }, $el.filters)
            , "post").then(() => {
                table.setSort(sort);
                $body.removeClass('is-loading');
            });
        }

        function payUnpaidReceipts (data, type) {
            $body.addClass('is-loading');
            $.ajax({
                url: '/' + window.currentLang + '/Receipts/PostPayReceipts',
                type: 'post',
                data: {
                    Type: type,
                    ReceiptsId: data,
                    Rownum: unpaidReceiptsPageSize,
                    Reccount: unpaidReceiptsCurrentPage,
                    PaymentSystem: 0
                },
                success: (response) => {
                    $('.js-unpaid-receipts-response').html(response);
                },
                fail: (response) => {
                    console.error(response);
                }
            }).always(() => {
                $body.removeClass('is-loading');
            })
        }

        function processFinalData(initialData){
            loyaltyData = [];
            Object.keys(initialData).forEach((key) => {
                let $row = $(`#${key}`);
                let oldData = Object.assign({}, initialData[key]);
                let newData = Object.assign({}, initialData[key]);
                let addedScore = parseInt($row.find('[data-score-amount] input').val(), 10);
                oldData['isChanged'] = false;
                newData['isChanged'] = true;
                newData['myDisableByHead'] = $row.find('[data-toggle-score]').is(':checked');
                if (!isNaN(addedScore)) {
                    newData['addedScore'] = addedScore;
                }
                loyaltyData.push(oldData, newData);
                let parentOrganization = window.model.filter((item) => {
                    return item.isParent === true;
                });
                loyaltyData.push(parentOrganization[0]);
            });
            const $button = $('[data-send-distrib-request]');
            setButtonState($button, loyaltyData.length > 0 && $('#scoreUsage').is(':checked'));
        }

        function checkSelectedData() {
            if (table.getSelectedData().length > 0) {
                $selectAll.text(table.getSelectedData().length + '-' + table.getData().length);
                $el.find('[data-score-amount] input').val(null).prop('disabled', true).trigger('change');
                $el.find('[data-toggle-score]').prop('disabled', true);
                $('[data-send-distrib-request]').parent().addClass('_hide');
                $loyaltyHeader.removeClass('_hide');
            } else {
                $el.find('[data-score-amount] input').removeAttr('disabled');
                $el.find('[data-toggle-score]').removeAttr('disabled');
                $('[data-send-distrib-request]').parent().removeClass('_hide');
                $loyaltyHeader.addClass('_hide');
            }
        }

        function setButtonState($button, state = false) {
            if (state) {
                $button.removeAttr('disabled');
            } else {
                $button.attr('disabled', true);
            }
        }

        function getOrderInfo(orderNumber) {
            const orderItem = initialData.filter(function(item) {
                return parseInt(item['AppNumber'], 10) === parseInt(orderNumber, 10);
            });
            let orderData = orderItem[0];
            const $container = $('#orderListPopup');
            $container.addClass('is-loading');
            $container.find('[data-order-type]').text(orderData['PickDelivStr']);
            $container.find('[data-order-status]').text(orderData['AppStateStr']);
            let dateDelivery = orderData['AppDate'].replace(/[^0-9.]+/g,"");
            let deliveryDate = new Date(parseInt(dateDelivery, 10));
            $container.find('[data-average-date]').text(deliveryDate.toLocaleDateString(window.currentLang));
            let timeFrom = new Date(orderData['AppTime']['from']).toLocaleTimeString(window.currentLang,  { timeZone: 'UTC' });
            let timeTo = new Date(orderData['AppTime']['to']).toLocaleTimeString(window.currentLang,  { timeZone: 'UTC' });
            timeFrom = timeFrom.split(':');
            let timeFromClear = timeFrom.slice(0,-1).join(':');
            timeTo = timeTo.split(':');
            let timeToClear = timeTo.slice(0,-1).join(':');
            let payType = getPaymentType(orderData['payType']);
            let additionalInfo = [];
            $container.find('[data-receipts-container]').html('');
            // orderData['Receipts'] = [
            //     {
            //         ReceiptId: '12312312', //id квитанции
            //         ReceiptNumber: '123123123', //номер квитанции
            //         ReceiptType: '123123123', //тип квитанции (из справочника типов)
            //         WarehouseSending: '123123123', //склад отправки
            //         WarehouseRecieving: '123123123', //склад получения
            //         Sender: '123123123', //отправитель
            //         Reciever: '123123123', //получатель
            //         Payer: '123123123', //плательщик
            //         PayType: '123123123', //тип оплаты, true - безнал, false - нал
            //         Places: '123123123', //кол-во мест
            //         Weight: '123123123', //вес
            //         Volume: '123123123', //объём
            //         CostDU: '123123123', //стоимость доп. услуг
            //         CostTotal: '123123123', //обзая стоимость
            //         PaymentStatus: '123123123'// статус оплаты
            //     },
            //     {
            //         ReceiptId: '12312312', //id квитанции
            //         ReceiptNumber: '123123123', //номер квитанции
            //         ReceiptType: '123123123', //тип квитанции (из справочника типов)
            //         WarehouseSending: '123123123', //склад отправки
            //         WarehouseRecieving: '123123123', //склад получения
            //         Sender: '123123123', //отправитель
            //         Reciever: '123123123', //получатель
            //         Payer: '123123123', //плательщик
            //         PayType: '123123123', //тип оплаты, true - безнал, false - нал
            //         Places: '123123123', //кол-во мест
            //         Weight: '123123123', //вес
            //         Volume: '123123123', //объём
            //         CostDU: '123123123', //стоимость доп. услуг
            //         CostTotal: '123123123', //обзая стоимость
            //         PaymentStatus: '123123123'// статус оплаты
            //     }
            // ];
            if (orderData['Receipts'].length > 0) {
                $container.find('[data-receipts-container]').html('');
                orderData['Receipts'].forEach((item, index) => {
                    let $receiptTemplate = $($container.find('#receipt-item').html());
                    if(item['ReceiptType'] === 100000002) {
                        $receiptTemplate.find('[data-receipt-number]').text(item['ReceiptNumber']);
                        $receiptTemplate.find('[data-receive-route]').text(item['WarehouseRecieving']);
                        $receiptTemplate.find('[data-receive-user]').text(item['Reciever']);
                        $receiptTemplate.attr('href', GLOBAL_APP_PATH + window.currentLang + '/Receipts/DetailsFull/' + item['ReceiptNumber']);
                        $container.find('[data-receipts-container]').append($receiptTemplate);
                    }
                   // $receiptTemplate.find('[data-receipt-status]').text(item['WarehouseRecieving']);
                });
            } else {
                $container.find('[data-receipts-container]').append(`<div class="text-16 _color-dark-gray text-bold">${translates.noReceiptsJournal}</div>`)
            }
            if (orderData['hydrobort']) {
                additionalInfo.push(translates.additionalInfo.hydrobort);
            }
            if (orderData['needAuto']) {
                additionalInfo.push(translates.additionalInfo.needAuto);
            }
            if (orderData['dontCall']) {
                additionalInfo.push(translates.additionalInfo.dontCall);
            }
            if (orderData['additionalPacking']) {
                additionalInfo.push(translates.additionalInfo.addPacking);
            }
            if (parseInt(orderData['halfDiscount'], 10) !== 100000000) {
                additionalInfo.push(translates.additionalInfo.halfDiscount);
            }
            $container.find('[data-average-time]').text(timeFromClear + '-' + timeToClear);
            $container.find('[data-order-number]').text(orderData['AppNumber']);
            $container.find('[data-address]').val(orderData['cityText'] + ', ' + orderData['addressText']);
            $container.find('[data-user-name]').text(orderData['senderName']);
            $container.find('[data-user-mail]').text(orderData['senderEmail']);
            $container.find('[data-user-mail-link]').attr('href', 'mailto:' + orderData['senderEmail']);
            $container.find('[data-user-phone]').text(orderData['SenderPhone']);
            $container.find('[data-user-phone-link]').attr('href', 'tel:' + orderData['SenderPhone']);
            $container.find('[data-contact-phone]').text(orderData['ContactPhone']);
            $container.find('[data-contact-phone-link]').attr('href', 'tel:' + orderData['ContactPhone']);
            $container.find('[data-places]').text(orderData['Places'] + ' ' + declOfNum(parseInt(orderData['Places'], 10), translates.places));
            $container.find('[data-weight]').text((orderData['Weight'] ?? 0) + ' ' + translates.weight);
            $container.find('[data-volume]').text((orderData['Volume'] ?? 0) + ' ' + translates.volume);
            $container.find('[data-pay-type]').text(payType);
            if (parseInt(orderData['Places'], 10) !== 0 && parseInt(orderData['Weight'], 10) !== 0 && parseInt(orderData['Volume'], 10) !== 0) {
                $container.find('[data-cargo-params]').removeClass('_hide');
            } else {
                $container.find('[data-cargo-params]').addClass('_hide');
            }
                if (additionalInfo.length > 0) {
                $container.find('[data-additional]').removeClass('_hide');
                $container.find('[data-additional-info]').text(additionalInfo.join('. '));
            } else {
                $container.find('[data-additional]').addClass('_hide');
            }
            if  (orderData['Comment']) {
                $container.find('[data-comment]').removeClass('_hide')
                $container.find('[data-delivery-comment]').text(orderData['Comment']);
            } else {
                $container.find('[data-comment]').addClass('_hide');
            }
            $container.removeClass('is-loading');
        }

        function getReclamationInfo(reclamationNumber) {
            const reclamationItem = initialData.filter(function(item) {
                return parseInt(item['investigationName'], 10) === parseInt(reclamationNumber, 10);
            });
            let reclamationData = reclamationItem[0];
            const $container = $('#reclamationPopup');
            $container.addClass('is-loading');
            $container.find('[data-reclam-number]').text(reclamationData['investigationName']);
            $container.find('[data-reclam-status]').text(reclamationData['decisionName'] !== null ? reclamationData['decisionName'] : translates.stateName.state6);
            $container.find('[data-reclam-registration]').text(reclamationData['registrationDate']);
            $container.find('[data-reclam-declaredCost]').text(reclamationData['declaredCost']);
            $container.find('[data-reclam-costForReturn]').text(reclamationData['costForReturn'] === null ? '0' : reclamationData['costForReturn']);
            $container.find('[data-reclam-employee-name]').text(reclamationData['employeeName']);
            $container.find('[data-reclam-employee-email]').text(reclamationData['employeeEmail']);
            $container.find('[data-reclam-employee-email]').attr('href', 'mailto:' + reclamationData['employeeEmail']);
            $container.find('[data-reclam-employee-phone]').text(reclamationData['employeePhone']);
            $container.find('[data-reclam-employee-phone]').attr('href', 'tel:' + reclamationData['employeePhone']);
            $container.find('[data-reclam-problem-type]').text(reclamationData['problemTypeName']);
            $container.find('[data-reclam-description]').text(reclamationData['description']);
            if(reclamationData['dateOfCompensation'] === null) {
                $container.find('[data-reclam-consideration]').text(reclamationData['termOfApproval']);
                $container.find('[data-consideration]').removeClass('_hide');
                $container.find('[data-reimbursement]').addClass('_hide');
            } else {
                $container.find('[data-reclam-consideration]').text(reclamationData['dateOfCompensation']);
                $container.find('[data-consideration]').addClass('_hide');
                $container.find('[data-reimbursement]').removeClass('_hide');
            }
            $container.find('[data-receipts-container]').html('');
            let $receiptTemplate = $($container.find('#receipt-item').html());
            $receiptTemplate.find('[data-receipt-number]').text(reclamationData['receiptName']);
            $receiptTemplate.attr('href', GLOBAL_APP_PATH + window.currentLang + '/Receipts/DetailsFull/' + reclamationData['receiptName']);
            $container.find('[data-receipts-container]').append($receiptTemplate);
            $container.removeClass('is-loading');
        }

        function downloadOrder(orderNumber) {
            $body.addClass('is-loading');
            $.ajax({
                url: GLOBAL_APP_PATH + window.currentLang + '/UserReceipts/ExportAppData',
                method: 'post',
                data: {
                    "appNumber" : orderNumber
                },
                success: function (response) {
                    $('#ExcelExport').html(response);
                    const string = `<meta http-equiv="Content-Type" content="text/html; charset=utf-8">`
                    const parser = new DOMParser();
                    const html = $('#ExcelExport').html();
                    const document = parser.parseFromString(html, "text/html");
                    const tdItems = document.querySelectorAll('td');
                    tdItems.forEach((element) => {
                        if(element.textContent.indexOf(',') > 0) {
                            element.textContent = element.textContent.replace(',', '.');
                        }
                    })
                    $('#ExcelExport').html(document.body);
                    $('#ExcelExport').prepend(string);

                    let wb = XLSX.utils.table_to_book($('#ExcelExport').get(0));
                    var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
                    saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), `${orderNumber}.xlsx`);
                    $body.removeClass('is-loading');
                }
            });
        }

        function exportExcel() {
            const data = table.getSelectedData();
            let finalData = [];
            data.forEach((item, index) => {
                finalData.push(item['id']);
            });

            if (finalData.length > 0) {
                $body.addClass('is-loading');
                $.ajax({
                    url: GLOBAL_APP_PATH + window.currentLang + '/UserReceipts/ExportDataById',
                    data: JSON.stringify({
                        "receiptId": finalData
                    }),
                    contentType: 'application/json',
                    type: 'post',
                    success: (response) => {
                        downloadExcel(response);
                        $body.removeClass('is-loading');
                    }
                });
            } else {
                $body.addClass('is-loading');
                let data = Object.assign({}, $el.filters);
                data.page = 1;
                data.size = 100000;
                $.ajax({
                    url: GLOBAL_APP_PATH + window.currentLang + '/UserReceipts/ExportData',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    type: 'post',
                    success: (response) => {
                        downloadExcel(response);
                        $body.removeClass('is-loading');
                    }
                }).always(() => {
                    $body.removeClass('is-loading');
                });
            }
        }

        function exportLpExcel(input) {
            $body.addClass('is-loading');
            $.ajax({
                url: GLOBAL_APP_PATH + window.currentLang + '/LoyaltyProgram/ExportScore',
                data: input,
                contentType: 'application/json',
                type: 'post',
                success: (response) => {
                    downloadExcel(response);
                    $body.removeClass('is-loading');
                }
            }).always(() => {
                $body.removeClass('is-loading');
            });
        }

        function downloadExcel(response) {
            let $table = $('#ExcelExport');
            $table.html(response);
            let string = `<meta http-equiv="Content-Type" content="text/html; charset=utf-8">`
            let parser = new DOMParser();
            let htmlString = $table.html();
            let doc = parser.parseFromString(htmlString, "text/html");
            let tdItems = doc.querySelectorAll('td');
            tdItems.forEach((element) => {
                if(element.textContent.indexOf(',') > 0) {
                    element.textContent = element.textContent.replace(',', '.');
                }
            });
            $table.html(doc.body);
            $table.prepend(string);
            let wb = XLSX.utils.table_to_book($table.get(0), {raw: true});
            let wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
            saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Export.xlsx');
        }

        function cancelOrder(orderNumber) {
            $body.addClass('is-loading');
            $.ajax({
                url: GLOBAL_APP_PATH + window.currentLang + '/Receipts/CancelOrder',
                method: 'post',
                data: {
                    "orderId" : orderNumber,
                    "tokenId" : window.tokenId
                },
                success: function (response) {
                    if (response.status) {
                        notifier.success(translates.orderCanceled).then((noty) => {
                            noty.show();
                        })
                    } else {
                        notifier.error(response.message).then((noty) => {
                            noty.show();
                        })
                    }
                    $body.removeClass('is-loading');
                }
            });
        }

        function getPaymentType(payType) {
            switch(parseInt(payType, 10)) {
                case 0:
                    return translates.payCash;
                case 1:
                    return translates.payCashless;
            }
        }

        function toggleDisabledButtons() {
            if (window.tableData.length === 0) {
                $tableToolbarButtons.attr('disabled', true);
            } else {
                $tableToolbarButtons.removeAttr('disabled');
            }
        }

        function closeEnableButtons() {
            if (window.tableData.length === 0) {
                $tableToolbarButtonsEnable.attr('disabled', true);
            }
        }

        function toggleTeyButton () {
            if (unpaidReceiptsSelected.tey.length) {
                $payTeyButton.removeAttr('disabled');
            } else {
                $payTeyButton.attr('disabled', true);
            }
        }

        function toggleInsuranceButton () {
            if (unpaidReceiptsSelected.insurance.length) {
                $payInsuranceButton.removeAttr('disabled');
            } else {
                $payInsuranceButton.attr('disabled', true);
            }
        }
        
        function toggleUnpaidReceiptsButtons () {
            toggleTeyButton();
            toggleInsuranceButton();
        }
        
        function selectUnpaidReceipts (data) {
            const $teyStatus = data['paymentStatus'];
            const $insuranceStatus = data['insurancePaymentStatus'];
            const id = data['id'];

            if (!$teyStatus && !unpaidReceiptsSelected.tey.includes(id)) {
                unpaidReceiptsSelected.tey.push(id);
            }

            if (!$insuranceStatus && !unpaidReceiptsSelected.insurance.includes(id)) {
                unpaidReceiptsSelected.insurance.push(id);
            }

            $selectAll.prop('checked', table.getData().length === table.getSelectedData().length);
        }
        
        function deselectUnpaidReceipts (data) {
            const id = data['id'];

            unpaidReceiptsSelected.tey = unpaidReceiptsSelected.tey.filter(el => el !== id);
            unpaidReceiptsSelected.insurance = unpaidReceiptsSelected.insurance.filter(el => el !== id);

            $selectAll.prop('checked', table.getData().length === table.getSelectedData().length);
        }

        function print(data, printType) {
            $body.addClass('is-loading');
            data = data.join(',')
            if (data.length > 0) {
                $.ajax({
                    url: '/' + window.currentLang + '/Receipts/ExportPrintForm',
                    type: 'post',
                    responseType: 'blob',
                    data: {
                        billId: data,
                        type: printType.toString(),
                    },
                    xhrFields: {
                        responseType: 'blob'
                    },
                    success: (blob, status, xhr) => {
                        let filename = "";
                        let disposition = xhr.getResponseHeader('Content-Disposition');
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            let matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                        }
                        
                        if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            window.navigator.msSaveBlob(blob, filename);
                        } else {
                            let URL = window.URL || window.webkitURL;
                            let downloadUrl = URL.createObjectURL(blob);

                            if (filename) {
                                let a = document.createElement("a");
                                if (typeof a.download === 'undefined') {
                                    window.location.href = downloadUrl;
                                } else {
                                    a.href = downloadUrl;
                                    a.download = filename;
                                    document.body.appendChild(a);
                                    a.click();
                                }
                            } else {
                                window.location.href = downloadUrl;
                            }

                            setTimeout(function () {
                                URL.revokeObjectURL(downloadUrl);
                            }, 100); // cleanup
                        }
                        $body.removeClass('is-loading');
                    }
                })
            }
        }

        function printRegistered(data) {
            if (data.length > 0) {
                $body.addClass('is-loading');
                let ids = '';
                for (let id of data) {
                    ids += 'ids=' + id + '&';
                }
                $.ajax({
                    url: '/' + window.currentLang + '/Receipts/GetRegisterReceipts' + '?' + ids,
                    type: 'get',
                    data: {
                        type: 1
                    },
                    success: (response) => {
                        // $('#printRegistered').html(response);

                        printJS({printable: response, type: 'raw-html'});
                        //     $('#printRegistered').printThis({
                        //     importCSS: false, // import page CSS
                        //     printContainer: false,
                        //     importStyle: true
                        // });
                    }
                }).always(() => {
                    $body.removeClass('is-loading');
                });
            }
        }

        function getPageSize(tableType) {
            switch(tableType) {
                case 'receipts':
                    return receiptPageSize;
                case 'ordersList':
                    return ordersPageSize;
                case 'archive':
                    return archivePageSize;
                case 'unpaidReceipts':
                    return unpaidReceiptsPageSize;
                default:
                    return 10;
            }
        }

        function getPage(tableType) {
            switch(tableType) {
                case 'receipts':
                    return receiptCurrentPage;
                case 'ordersList':
                    return ordersCurrentPage;
                case 'archive':
                    return archiveCurrentPage;
                case 'unpaidReceipts':
                    return unpaidReceiptsCurrentPage;
                default:
                    return 1;
            }
        }

        $(window).on('columnUpdate', () => {
            let columnName = $(window).data('column');
            let prevColumn = $(window).data('prevColumn');
            table.moveColumn(table.moveColumn(columnName, prevColumn, true));
        });

        function isFilter () {
            let headerFilter = $('.tabulator-header-filter');
            headerFilter.each((i, el) => {
                const $el = $(el);

                if($el.find('[data-filter]').hasClass('is-filtered')) {
                    $('[data-reset-filter]').removeClass('_hide');
                }
            })
        }

        $(document).on('click', '[data-filter]', function() {
            let tabulatorCol = $('.tabulator-headers .tabulator-col');
            if(tabulatorCol.last().hasClass('filter-opened')) {
                tabulatorCol.last().find('[data-dropdown-content]').css({'left': 'inherit', 'right': '50%'});
            }
        });


        $(document).on('click', '[data-reset-filter]', function() {
            let headerFilter = $('.tabulator-header-filter');

            headerFilter.each((i, el) => {
                const $el = $(el);
                const content = $el.find('[data-dropdown-content]')

                if($el.find('[data-filter]').hasClass('is-filtered')) {
                    content.find('[data-reset]').trigger('click');
                    setTimeout(function () {
                        content.find('[data-confirm]').trigger('click');
                    }, 200);
                    $('[data-filter-container]').remove();
                    $('[data-reset-filter]').addClass('_hide');
                    $('body').click();
                }
            })

            getClientReceivers();
        });

        $(document).on('mousedown', '.tabulator-scrollWrapper', function() {
            let header = $('.tabulator-headers');

            header.each((i, el) => {
                const $el = $(el);
                const dropdown = $el.find('[data-dropdown]')

                if($el.find('.tabulator-col').hasClass('filter-opened')) {
                    $el.find('.tabulator-col').removeClass('filter-opened');
                    dropdown.removeClass('is-opened');
                }
            })
        });

        $(document).on('click', '[data-reset-send-date]', function() {
            let editor = $('#dateSendEditor');
            editor.find('[data-reset]').trigger('click');
            editor.find('[data-confirm]').trigger('click');

            $(this).parents('[data-filter-container]').remove();
            $('[data-reset-filter]').addClass('_hide');
            getClientReceivers();
        });

        function getClientReceivers() {
            const $receiverList =  $('.tabulator-header-filter').find('[data-receiver-list]');

            $.ajax({
                url: GLOBAL_APP_PATH + '/' + window.currentLang + '/UserReceipts/getClientReceivers',
                type: 'POST',
                data: $el.filters,
                success: (response) => {
                    let receiverItems = response.map((item, index) => {
                        return (`
                            <li id="${item['Value']}" class="dropdown-list__item ${URLParamsSearch.get('receiverId') === item['Value'] ? 'is-active' : '' }">
                                ${item['Text']}
                            </li>
                        `)
                    });
                    $receiverList.html(receiverItems.join(''));
                }
            });
        }
    });

    function s2ab(s) {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
}

export default function (elements) {
    tabulator(elements);
}